import { r as __toESM$1, t as require_json_schema_traverse } from "./json-schema-traverse-B35mHRM8.js";
import { ensureAllPropertiesRequired, prepareJsonSchemaForOpenAIStrictMode, zodToJsonSchema as zodToJsonSchema$1 } from "./zod-to-json.js";
import { a as standardSchemaToJSONSchema, i as isStandardSchemaWithJSON, n as isStandardJSONSchema, o as toStandardSchema, r as isStandardSchema, t as JSON_SCHEMA_LIBRARY_OPTIONS } from "./schema-Bv9OdW1f.js";
import { ZodArray, ZodDate, ZodDefault, ZodFirstPartyTypeKind, ZodIntersection, ZodNull, ZodNullable, ZodNumber, ZodObject, ZodOptional, ZodString, ZodUnion, z } from "zod/v3";
import { z as z$1 } from "zod";
import { convertJsonSchemaToZod } from "zod-from-json-schema";
import { ZodArray as ZodArray$1, ZodDate as ZodDate$1, ZodDefault as ZodDefault$1, ZodIntersection as ZodIntersection$1, ZodNull as ZodNull$1, ZodNullable as ZodNullable$1, ZodNumber as ZodNumber$1, ZodObject as ZodObject$1, ZodOptional as ZodOptional$1, ZodString as ZodString$1, ZodUnion as ZodUnion$1, z as z$2 } from "zod/v4";
//#region ../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@/zod-from-json-schema/0.0.5/8e273a13436172e49bb0898e3f9caf0fd3966851d12111764522ea958a085aeb/node_modules/zod-from-json-schema/dist/index.mjs
function convertJsonSchemaToZod$1(schema) {
	function addMetadata(zodSchema, jsonSchema) {
		if (jsonSchema.description) zodSchema = zodSchema.describe(jsonSchema.description);
		return zodSchema;
	}
	if (schema.const !== void 0) {
		if (typeof schema.const === "string") return addMetadata(z$1.literal(schema.const), schema);
		else if (typeof schema.const === "number") return addMetadata(z$1.literal(schema.const), schema);
		else if (typeof schema.const === "boolean") return addMetadata(z$1.literal(schema.const), schema);
		else if (schema.const === null) return addMetadata(z$1.null(), schema);
		return addMetadata(z$1.literal(schema.const), schema);
	}
	if (schema.type) switch (schema.type) {
		case "string": {
			if (schema.enum) {
				if (schema.enum.length === 0) return addMetadata(z$1.string(), schema);
				return addMetadata(z$1.enum(schema.enum), schema);
			}
			let stringSchema = z$1.string();
			if (schema.minLength !== void 0) stringSchema = stringSchema.min(schema.minLength);
			if (schema.maxLength !== void 0) stringSchema = stringSchema.max(schema.maxLength);
			if (schema.pattern !== void 0) {
				const regex = new RegExp(schema.pattern);
				stringSchema = stringSchema.regex(regex);
			}
			return addMetadata(stringSchema, schema);
		}
		case "number":
		case "integer": {
			if (schema.enum) {
				if (schema.enum.length === 0) return addMetadata(z$1.number(), schema);
				const options = schema.enum.map((val) => z$1.literal(val));
				if (options.length === 1) return addMetadata(options[0], schema);
				if (options.length >= 2) return addMetadata(z$1.union([
					options[0],
					options[1],
					...options.slice(2)
				]), schema);
			}
			let numberSchema = schema.type === "integer" ? z$1.number().int() : z$1.number();
			if (schema.minimum !== void 0) numberSchema = numberSchema.min(schema.minimum);
			if (schema.maximum !== void 0) numberSchema = numberSchema.max(schema.maximum);
			if (schema.exclusiveMinimum !== void 0) numberSchema = numberSchema.gt(schema.exclusiveMinimum);
			if (schema.exclusiveMaximum !== void 0) numberSchema = numberSchema.lt(schema.exclusiveMaximum);
			if (schema.multipleOf !== void 0) numberSchema = numberSchema.multipleOf(schema.multipleOf);
			return addMetadata(numberSchema, schema);
		}
		case "boolean":
			if (schema.enum) {
				if (schema.enum.length === 0) return addMetadata(z$1.boolean(), schema);
				const options = schema.enum.map((val) => z$1.literal(val));
				if (options.length === 1) return addMetadata(options[0], schema);
				if (options.length >= 2) return addMetadata(z$1.union([
					options[0],
					options[1],
					...options.slice(2)
				]), schema);
			}
			return addMetadata(z$1.boolean(), schema);
		case "null": return addMetadata(z$1.null(), schema);
		case "object":
			if (schema.properties) {
				const shape = {};
				for (const [key, propSchema] of Object.entries(schema.properties)) shape[key] = convertJsonSchemaToZod$1(propSchema);
				if (schema.required && Array.isArray(schema.required)) {
					const required = new Set(schema.required);
					for (const key of Object.keys(shape)) if (!required.has(key)) shape[key] = shape[key].optional();
				} else for (const key of Object.keys(shape)) shape[key] = shape[key].optional();
				let zodSchema;
				if (schema.additionalProperties !== false) zodSchema = z$1.object(shape).passthrough();
				else zodSchema = z$1.object(shape);
				return addMetadata(zodSchema, schema);
			}
			return addMetadata(z$1.object({}), schema);
		case "array": {
			let arraySchema;
			if (schema.items) arraySchema = z$1.array(convertJsonSchemaToZod$1(schema.items));
			else arraySchema = z$1.array(z$1.any());
			if (schema.minItems !== void 0) arraySchema = arraySchema.min(schema.minItems);
			if (schema.maxItems !== void 0) arraySchema = arraySchema.max(schema.maxItems);
			if (schema.uniqueItems === true) arraySchema = arraySchema.refine((items) => {
				const seen = /* @__PURE__ */ new Set();
				return items.every((item) => {
					if (typeof item === "string" || typeof item === "number" || typeof item === "boolean") {
						if (seen.has(item)) return false;
						seen.add(item);
						return true;
					}
					const serialized = JSON.stringify(item);
					if (seen.has(serialized)) return false;
					seen.add(serialized);
					return true;
				});
			}, { message: "Array items must be unique" });
			return addMetadata(arraySchema, schema);
		}
	}
	if (schema.enum) {
		if (schema.enum.length === 0) return addMetadata(z$1.never(), schema);
		if (schema.enum.every((val) => typeof val === "string")) return addMetadata(z$1.enum(schema.enum), schema);
		else {
			const options = schema.enum.map((val) => z$1.literal(val));
			if (options.length === 1) return addMetadata(options[0], schema);
			if (options.length >= 2) return addMetadata(z$1.union([
				options[0],
				options[1],
				...options.slice(2)
			]), schema);
		}
	}
	if (schema.anyOf && schema.anyOf.length >= 2) {
		const schemas = schema.anyOf.map(convertJsonSchemaToZod$1);
		return addMetadata(z$1.union([
			schemas[0],
			schemas[1],
			...schemas.slice(2)
		]), schema);
	}
	if (schema.allOf) return addMetadata(schema.allOf.reduce((acc, s) => z$1.intersection(acc, convertJsonSchemaToZod$1(s)), z$1.object({})), schema);
	if (schema.oneOf && schema.oneOf.length >= 2) {
		const schemas = schema.oneOf.map(convertJsonSchemaToZod$1);
		return addMetadata(z$1.union([
			schemas[0],
			schemas[1],
			...schemas.slice(2)
		]), schema);
	}
	return addMetadata(z$1.any(), schema);
}
//#endregion
//#region ../_vendored/ai_v4/dist/dist-Cm5DZgxA.js
var marker$1 = "vercel.ai.error";
var symbol$1 = Symbol.for(marker$1);
var _a$1;
var _AISDKError = class _AISDKError extends Error {
	/**
	* Creates an AI SDK Error.
	*
	* @param {Object} params - The parameters for creating the error.
	* @param {string} params.name - The name of the error.
	* @param {string} params.message - The error message.
	* @param {unknown} [params.cause] - The underlying cause of the error.
	*/
	constructor({ name: name14, message, cause }) {
		super(message);
		this[_a$1] = true;
		this.name = name14;
		this.cause = cause;
	}
	/**
	* Checks if the given error is an AI SDK Error.
	* @param {unknown} error - The error to check.
	* @returns {boolean} True if the error is an AI SDK Error, false otherwise.
	*/
	static isInstance(error) {
		return _AISDKError.hasMarker(error, marker$1);
	}
	static hasMarker(error, marker15) {
		const markerSymbol = Symbol.for(marker15);
		return error != null && typeof error === "object" && markerSymbol in error && typeof error[markerSymbol] === "boolean" && error[markerSymbol] === true;
	}
};
_a$1 = symbol$1;
var AISDKError = _AISDKError;
function getErrorMessage(error) {
	if (error == null) return "unknown error";
	if (typeof error === "string") return error;
	if (error instanceof Error) return error.message;
	return JSON.stringify(error);
}
var name3$1 = "AI_InvalidArgumentError";
var marker4$1 = `vercel.ai.error.${name3$1}`;
var symbol4$1 = Symbol.for(marker4$1);
var _a4$1;
var InvalidArgumentError = class extends AISDKError {
	constructor({ message, cause, argument }) {
		super({
			name: name3$1,
			message,
			cause
		});
		this[_a4$1] = true;
		this.argument = argument;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker4$1);
	}
};
_a4$1 = symbol4$1;
var name6$1 = "AI_JSONParseError";
var marker7$1 = `vercel.ai.error.${name6$1}`;
var symbol7$1 = Symbol.for(marker7$1);
var _a7$1;
var JSONParseError = class extends AISDKError {
	constructor({ text, cause }) {
		super({
			name: name6$1,
			message: `JSON parsing failed: Text: ${text}.
Error message: ${getErrorMessage(cause)}`,
			cause
		});
		this[_a7$1] = true;
		this.text = text;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker7$1);
	}
};
_a7$1 = symbol7$1;
var name12$1 = "AI_TypeValidationError";
var marker13$1 = `vercel.ai.error.${name12$1}`;
var symbol13$1 = Symbol.for(marker13$1);
var _a13$1;
var _TypeValidationError = class _TypeValidationError extends AISDKError {
	constructor({ value, cause }) {
		super({
			name: name12$1,
			message: `Type validation failed: Value: ${JSON.stringify(value)}.
Error message: ${getErrorMessage(cause)}`,
			cause
		});
		this[_a13$1] = true;
		this.value = value;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker13$1);
	}
	/**
	* Wraps an error into a TypeValidationError.
	* If the cause is already a TypeValidationError with the same value, it returns the cause.
	* Otherwise, it creates a new TypeValidationError.
	*
	* @param {Object} params - The parameters for wrapping the error.
	* @param {unknown} params.value - The value that failed validation.
	* @param {unknown} params.cause - The original error or cause of the validation failure.
	* @returns {TypeValidationError} A TypeValidationError instance.
	*/
	static wrap({ value, cause }) {
		return _TypeValidationError.isInstance(cause) && cause.value === value ? cause : new _TypeValidationError({
			value,
			cause
		});
	}
};
_a13$1 = symbol13$1;
var TypeValidationError = _TypeValidationError;
//#endregion
//#region ../_vendored/ai_v4/dist/index.js
var __create = Object.create;
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod), cb = null), mod.exports);
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp$1(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp$1(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));
let customAlphabet = (alphabet, defaultSize = 21) => {
	return (size = defaultSize) => {
		let id = "";
		let i = size | 0;
		while (i--) id += alphabet[Math.random() * alphabet.length | 0];
		return id;
	};
};
var import_secure_json_parse = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	const hasBuffer = typeof Buffer !== "undefined";
	const suspectProtoRx = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/;
	const suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
	function _parse(text, reviver, options) {
		if (options == null) {
			if (reviver !== null && typeof reviver === "object") {
				options = reviver;
				reviver = void 0;
			}
		}
		if (hasBuffer && Buffer.isBuffer(text)) text = text.toString();
		if (text && text.charCodeAt(0) === 65279) text = text.slice(1);
		const obj = JSON.parse(text, reviver);
		if (obj === null || typeof obj !== "object") return obj;
		const protoAction = options && options.protoAction || "error";
		const constructorAction = options && options.constructorAction || "error";
		if (protoAction === "ignore" && constructorAction === "ignore") return obj;
		if (protoAction !== "ignore" && constructorAction !== "ignore") {
			if (suspectProtoRx.test(text) === false && suspectConstructorRx.test(text) === false) return obj;
		} else if (protoAction !== "ignore" && constructorAction === "ignore") {
			if (suspectProtoRx.test(text) === false) return obj;
		} else if (suspectConstructorRx.test(text) === false) return obj;
		return filter(obj, {
			protoAction,
			constructorAction,
			safe: options && options.safe
		});
	}
	function filter(obj, { protoAction = "error", constructorAction = "error", safe } = {}) {
		let next = [obj];
		while (next.length) {
			const nodes = next;
			next = [];
			for (const node of nodes) {
				if (protoAction !== "ignore" && Object.prototype.hasOwnProperty.call(node, "__proto__")) {
					if (safe === true) return null;
					else if (protoAction === "error") throw new SyntaxError("Object contains forbidden prototype property");
					delete node.__proto__;
				}
				if (constructorAction !== "ignore" && Object.prototype.hasOwnProperty.call(node, "constructor") && Object.prototype.hasOwnProperty.call(node.constructor, "prototype")) {
					if (safe === true) return null;
					else if (constructorAction === "error") throw new SyntaxError("Object contains forbidden prototype property");
					delete node.constructor;
				}
				for (const key in node) {
					const value = node[key];
					if (value && typeof value === "object") next.push(value);
				}
			}
		}
		return obj;
	}
	function parse(text, reviver, options) {
		const stackTraceLimit = Error.stackTraceLimit;
		Error.stackTraceLimit = 0;
		try {
			return _parse(text, reviver, options);
		} finally {
			Error.stackTraceLimit = stackTraceLimit;
		}
	}
	function safeParse(text, reviver) {
		const stackTraceLimit = Error.stackTraceLimit;
		Error.stackTraceLimit = 0;
		try {
			return _parse(text, reviver, { safe: true });
		} catch (_e) {
			return null;
		} finally {
			Error.stackTraceLimit = stackTraceLimit;
		}
	}
	module.exports = parse;
	module.exports.default = parse;
	module.exports.parse = parse;
	module.exports.safeParse = safeParse;
	module.exports.scan = filter;
})))(), 1);
function convertAsyncIteratorToReadableStream(iterator) {
	return new ReadableStream({
		/**
		* Called when the consumer wants to pull more data from the stream.
		*
		* @param {ReadableStreamDefaultController<T>} controller - The controller to enqueue data into the stream.
		* @returns {Promise<void>}
		*/
		async pull(controller) {
			try {
				const { value, done } = await iterator.next();
				if (done) controller.close();
				else controller.enqueue(value);
			} catch (error) {
				controller.error(error);
			}
		},
		/**
		* Called when the consumer cancels the stream.
		*/
		cancel() {}
	});
}
var createIdGenerator = ({ prefix, size: defaultSize = 16, alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", separator = "-" } = {}) => {
	const generator = customAlphabet(alphabet, defaultSize);
	if (prefix == null) return generator;
	if (alphabet.includes(separator)) throw new InvalidArgumentError({
		argument: "separator",
		message: `The separator "${separator}" must not be part of the alphabet "${alphabet}".`
	});
	return (size) => `${prefix}${separator}${generator(size)}`;
};
createIdGenerator();
var validatorSymbol = Symbol.for("vercel.ai.validator");
function validator(validate) {
	return {
		[validatorSymbol]: true,
		validate
	};
}
function isValidator(value) {
	return typeof value === "object" && value !== null && validatorSymbol in value && value[validatorSymbol] === true && "validate" in value;
}
function asValidator(value) {
	return isValidator(value) ? value : zodValidator(value);
}
function zodValidator(zodSchema) {
	return validator((value) => {
		const result = zodSchema.safeParse(value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	});
}
function safeValidateTypes({ value, schema }) {
	const validator2 = asValidator(schema);
	try {
		if (validator2.validate == null) return {
			success: true,
			value
		};
		const result = validator2.validate(value);
		if (result.success) return result;
		return {
			success: false,
			error: TypeValidationError.wrap({
				value,
				cause: result.error
			})
		};
	} catch (error) {
		return {
			success: false,
			error: TypeValidationError.wrap({
				value,
				cause: error
			})
		};
	}
}
function safeParseJSON({ text, schema }) {
	try {
		const value = import_secure_json_parse.default.parse(text);
		if (schema == null) return {
			success: true,
			value,
			rawValue: value
		};
		const validationResult = safeValidateTypes({
			value,
			schema
		});
		return validationResult.success ? {
			...validationResult,
			rawValue: value
		} : validationResult;
	} catch (error) {
		return {
			success: false,
			error: JSONParseError.isInstance(error) ? error : new JSONParseError({
				text,
				cause: error
			})
		};
	}
}
var { btoa, atob } = globalThis;
const ignoreOverride = Symbol("Let zodToJsonSchema decide on which parser to use");
const defaultOptions = {
	name: void 0,
	$refStrategy: "root",
	basePath: ["#"],
	effectStrategy: "input",
	pipeStrategy: "all",
	dateStrategy: "format:date-time",
	mapStrategy: "entries",
	removeAdditionalStrategy: "passthrough",
	allowedAdditionalProperties: true,
	rejectedAdditionalProperties: false,
	definitionPath: "definitions",
	target: "jsonSchema7",
	strictUnions: false,
	definitions: {},
	errorMessages: false,
	markdownDescription: false,
	patternStrategy: "escape",
	applyRegexFlags: false,
	emailStrategy: "format:email",
	base64Strategy: "contentEncoding:base64",
	nameStrategy: "ref",
	openAiAnyTypeName: "OpenAiAnyType"
};
const getDefaultOptions = (options) => typeof options === "string" ? {
	...defaultOptions,
	name: options
} : {
	...defaultOptions,
	...options
};
const getRefs = (options) => {
	const _options = getDefaultOptions(options);
	const currentPath = _options.name !== void 0 ? [
		..._options.basePath,
		_options.definitionPath,
		_options.name
	] : _options.basePath;
	return {
		..._options,
		flags: { hasReferencedOpenAiAnyType: false },
		currentPath,
		propertyPath: void 0,
		seen: new Map(Object.entries(_options.definitions).map(([name, def]) => [def._def, {
			def: def._def,
			path: [
				..._options.basePath,
				_options.definitionPath,
				name
			],
			jsonSchema: void 0
		}]))
	};
};
function addErrorMessage(res, key, errorMessage, refs) {
	if (!refs?.errorMessages) return;
	if (errorMessage) res.errorMessage = {
		...res.errorMessage,
		[key]: errorMessage
	};
}
function setResponseValueAndErrors(res, key, value, errorMessage, refs) {
	res[key] = value;
	addErrorMessage(res, key, errorMessage, refs);
}
const getRelativePath = (pathA, pathB) => {
	let i = 0;
	for (; i < pathA.length && i < pathB.length; i++) if (pathA[i] !== pathB[i]) break;
	return [(pathA.length - i).toString(), ...pathB.slice(i)].join("/");
};
function parseAnyDef(refs) {
	if (refs.target !== "openAi") return {};
	const anyDefinitionPath = [
		...refs.basePath,
		refs.definitionPath,
		refs.openAiAnyTypeName
	];
	refs.flags.hasReferencedOpenAiAnyType = true;
	return { $ref: refs.$refStrategy === "relative" ? getRelativePath(anyDefinitionPath, refs.currentPath) : anyDefinitionPath.join("/") };
}
function parseArrayDef(def, refs) {
	const res = { type: "array" };
	if (def.type?._def && def.type?._def?.typeName !== ZodFirstPartyTypeKind.ZodAny) res.items = parseDef(def.type._def, {
		...refs,
		currentPath: [...refs.currentPath, "items"]
	});
	if (def.minLength) setResponseValueAndErrors(res, "minItems", def.minLength.value, def.minLength.message, refs);
	if (def.maxLength) setResponseValueAndErrors(res, "maxItems", def.maxLength.value, def.maxLength.message, refs);
	if (def.exactLength) {
		setResponseValueAndErrors(res, "minItems", def.exactLength.value, def.exactLength.message, refs);
		setResponseValueAndErrors(res, "maxItems", def.exactLength.value, def.exactLength.message, refs);
	}
	return res;
}
function parseBigintDef(def, refs) {
	const res = {
		type: "integer",
		format: "int64"
	};
	if (!def.checks) return res;
	for (const check of def.checks) switch (check.kind) {
		case "min":
			if (refs.target === "jsonSchema7") if (check.inclusive) setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			else setResponseValueAndErrors(res, "exclusiveMinimum", check.value, check.message, refs);
			else {
				if (!check.inclusive) res.exclusiveMinimum = true;
				setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			}
			break;
		case "max":
			if (refs.target === "jsonSchema7") if (check.inclusive) setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			else setResponseValueAndErrors(res, "exclusiveMaximum", check.value, check.message, refs);
			else {
				if (!check.inclusive) res.exclusiveMaximum = true;
				setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			}
			break;
		case "multipleOf":
			setResponseValueAndErrors(res, "multipleOf", check.value, check.message, refs);
			break;
	}
	return res;
}
function parseBooleanDef() {
	return { type: "boolean" };
}
function parseBrandedDef(_def, refs) {
	return parseDef(_def.type._def, refs);
}
const parseCatchDef = (def, refs) => {
	return parseDef(def.innerType._def, refs);
};
function parseDateDef(def, refs, overrideDateStrategy) {
	const strategy = overrideDateStrategy ?? refs.dateStrategy;
	if (Array.isArray(strategy)) return { anyOf: strategy.map((item, i) => parseDateDef(def, refs, item)) };
	switch (strategy) {
		case "string":
		case "format:date-time": return {
			type: "string",
			format: "date-time"
		};
		case "format:date": return {
			type: "string",
			format: "date"
		};
		case "integer": return integerDateParser(def, refs);
	}
}
const integerDateParser = (def, refs) => {
	const res = {
		type: "integer",
		format: "unix-time"
	};
	if (refs.target === "openApi3") return res;
	for (const check of def.checks) switch (check.kind) {
		case "min":
			setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			break;
		case "max":
			setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			break;
	}
	return res;
};
function parseDefaultDef(_def, refs) {
	return {
		...parseDef(_def.innerType._def, refs),
		default: _def.defaultValue()
	};
}
function parseEffectsDef(_def, refs) {
	return refs.effectStrategy === "input" ? parseDef(_def.schema._def, refs) : parseAnyDef(refs);
}
function parseEnumDef(def) {
	return {
		type: "string",
		enum: Array.from(def.values)
	};
}
const isJsonSchema7AllOfType = (type) => {
	if ("type" in type && type.type === "string") return false;
	return "allOf" in type;
};
function parseIntersectionDef(def, refs) {
	const allOf = [parseDef(def.left._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"0"
		]
	}), parseDef(def.right._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"1"
		]
	})].filter((x) => !!x);
	let unevaluatedProperties = refs.target === "jsonSchema2019-09" ? { unevaluatedProperties: false } : void 0;
	const mergedAllOf = [];
	allOf.forEach((schema) => {
		if (isJsonSchema7AllOfType(schema)) {
			mergedAllOf.push(...schema.allOf);
			if (schema.unevaluatedProperties === void 0) unevaluatedProperties = void 0;
		} else {
			let nestedSchema = schema;
			if ("additionalProperties" in schema && schema.additionalProperties === false) {
				const { additionalProperties, ...rest } = schema;
				nestedSchema = rest;
			} else unevaluatedProperties = void 0;
			mergedAllOf.push(nestedSchema);
		}
	});
	return mergedAllOf.length ? {
		allOf: mergedAllOf,
		...unevaluatedProperties
	} : void 0;
}
function parseLiteralDef(def, refs) {
	const parsedType = typeof def.value;
	if (parsedType !== "bigint" && parsedType !== "number" && parsedType !== "boolean" && parsedType !== "string") return { type: Array.isArray(def.value) ? "array" : "object" };
	if (refs.target === "openApi3") return {
		type: parsedType === "bigint" ? "integer" : parsedType,
		enum: [def.value]
	};
	return {
		type: parsedType === "bigint" ? "integer" : parsedType,
		const: def.value
	};
}
let emojiRegex = void 0;
/**
* Generated from the regular expressions found here as of 2024-05-22:
* https://github.com/colinhacks/zod/blob/master/src/types.ts.
*
* Expressions with /i flag have been changed accordingly.
*/
const zodPatterns = {
	/**
	* `c` was changed to `[cC]` to replicate /i flag
	*/
	cuid: /^[cC][^\s-]{8,}$/,
	cuid2: /^[0-9a-z]+$/,
	ulid: /^[0-9A-HJKMNP-TV-Z]{26}$/,
	/**
	* `a-z` was added to replicate /i flag
	*/
	email: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_'+\-\.]*)[a-zA-Z0-9_+-]@([a-zA-Z0-9][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}$/,
	/**
	* Constructed a valid Unicode RegExp
	*
	* Lazily instantiate since this type of regex isn't supported
	* in all envs (e.g. React Native).
	*
	* See:
	* https://github.com/colinhacks/zod/issues/2433
	* Fix in Zod:
	* https://github.com/colinhacks/zod/commit/9340fd51e48576a75adc919bff65dbc4a5d4c99b
	*/
	emoji: () => {
		if (emojiRegex === void 0) emojiRegex = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
		return emojiRegex;
	},
	/**
	* Unused
	*/
	uuid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
	/**
	* Unused
	*/
	ipv4: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
	ipv4Cidr: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,
	/**
	* Unused
	*/
	ipv6: /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
	ipv6Cidr: /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,
	base64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
	base64url: /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,
	nanoid: /^[a-zA-Z0-9_-]{21}$/,
	jwt: /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/
};
function parseStringDef(def, refs) {
	const res = { type: "string" };
	if (def.checks) for (const check of def.checks) switch (check.kind) {
		case "min":
			setResponseValueAndErrors(res, "minLength", typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
			break;
		case "max":
			setResponseValueAndErrors(res, "maxLength", typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
			break;
		case "email":
			switch (refs.emailStrategy) {
				case "format:email":
					addFormat(res, "email", check.message, refs);
					break;
				case "format:idn-email":
					addFormat(res, "idn-email", check.message, refs);
					break;
				case "pattern:zod":
					addPattern(res, zodPatterns.email, check.message, refs);
					break;
			}
			break;
		case "url":
			addFormat(res, "uri", check.message, refs);
			break;
		case "uuid":
			addFormat(res, "uuid", check.message, refs);
			break;
		case "regex":
			addPattern(res, check.regex, check.message, refs);
			break;
		case "cuid":
			addPattern(res, zodPatterns.cuid, check.message, refs);
			break;
		case "cuid2":
			addPattern(res, zodPatterns.cuid2, check.message, refs);
			break;
		case "startsWith":
			addPattern(res, RegExp(`^${escapeLiteralCheckValue(check.value, refs)}`), check.message, refs);
			break;
		case "endsWith":
			addPattern(res, RegExp(`${escapeLiteralCheckValue(check.value, refs)}$`), check.message, refs);
			break;
		case "datetime":
			addFormat(res, "date-time", check.message, refs);
			break;
		case "date":
			addFormat(res, "date", check.message, refs);
			break;
		case "time":
			addFormat(res, "time", check.message, refs);
			break;
		case "duration":
			addFormat(res, "duration", check.message, refs);
			break;
		case "length":
			setResponseValueAndErrors(res, "minLength", typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
			setResponseValueAndErrors(res, "maxLength", typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
			break;
		case "includes":
			addPattern(res, RegExp(escapeLiteralCheckValue(check.value, refs)), check.message, refs);
			break;
		case "ip":
			if (check.version !== "v6") addFormat(res, "ipv4", check.message, refs);
			if (check.version !== "v4") addFormat(res, "ipv6", check.message, refs);
			break;
		case "base64url":
			addPattern(res, zodPatterns.base64url, check.message, refs);
			break;
		case "jwt":
			addPattern(res, zodPatterns.jwt, check.message, refs);
			break;
		case "cidr":
			if (check.version !== "v6") addPattern(res, zodPatterns.ipv4Cidr, check.message, refs);
			if (check.version !== "v4") addPattern(res, zodPatterns.ipv6Cidr, check.message, refs);
			break;
		case "emoji":
			addPattern(res, zodPatterns.emoji(), check.message, refs);
			break;
		case "ulid":
			addPattern(res, zodPatterns.ulid, check.message, refs);
			break;
		case "base64":
			switch (refs.base64Strategy) {
				case "format:binary":
					addFormat(res, "binary", check.message, refs);
					break;
				case "contentEncoding:base64":
					setResponseValueAndErrors(res, "contentEncoding", "base64", check.message, refs);
					break;
				case "pattern:zod":
					addPattern(res, zodPatterns.base64, check.message, refs);
					break;
			}
			break;
		case "nanoid": addPattern(res, zodPatterns.nanoid, check.message, refs);
		case "toLowerCase":
		case "toUpperCase":
		case "trim": break;
		default:
	}
	return res;
}
function escapeLiteralCheckValue(literal, refs) {
	return refs.patternStrategy === "escape" ? escapeNonAlphaNumeric(literal) : literal;
}
const ALPHA_NUMERIC = /* @__PURE__ */ new Set("ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvxyz0123456789");
function escapeNonAlphaNumeric(source) {
	let result = "";
	for (let i = 0; i < source.length; i++) {
		if (!ALPHA_NUMERIC.has(source[i])) result += "\\";
		result += source[i];
	}
	return result;
}
function addFormat(schema, value, message, refs) {
	if (schema.format || schema.anyOf?.some((x) => x.format)) {
		if (!schema.anyOf) schema.anyOf = [];
		if (schema.format) {
			schema.anyOf.push({
				format: schema.format,
				...schema.errorMessage && refs.errorMessages && { errorMessage: { format: schema.errorMessage.format } }
			});
			delete schema.format;
			if (schema.errorMessage) {
				delete schema.errorMessage.format;
				if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
			}
		}
		schema.anyOf.push({
			format: value,
			...message && refs.errorMessages && { errorMessage: { format: message } }
		});
	} else setResponseValueAndErrors(schema, "format", value, message, refs);
}
function addPattern(schema, regex, message, refs) {
	if (schema.pattern || schema.allOf?.some((x) => x.pattern)) {
		if (!schema.allOf) schema.allOf = [];
		if (schema.pattern) {
			schema.allOf.push({
				pattern: schema.pattern,
				...schema.errorMessage && refs.errorMessages && { errorMessage: { pattern: schema.errorMessage.pattern } }
			});
			delete schema.pattern;
			if (schema.errorMessage) {
				delete schema.errorMessage.pattern;
				if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
			}
		}
		schema.allOf.push({
			pattern: stringifyRegExpWithFlags(regex, refs),
			...message && refs.errorMessages && { errorMessage: { pattern: message } }
		});
	} else setResponseValueAndErrors(schema, "pattern", stringifyRegExpWithFlags(regex, refs), message, refs);
}
function stringifyRegExpWithFlags(regex, refs) {
	if (!refs.applyRegexFlags || !regex.flags) return regex.source;
	const flags = {
		i: regex.flags.includes("i"),
		m: regex.flags.includes("m"),
		s: regex.flags.includes("s")
	};
	const source = flags.i ? regex.source.toLowerCase() : regex.source;
	let pattern = "";
	let isEscaped = false;
	let inCharGroup = false;
	let inCharRange = false;
	for (let i = 0; i < source.length; i++) {
		if (isEscaped) {
			pattern += source[i];
			isEscaped = false;
			continue;
		}
		if (flags.i) {
			if (inCharGroup) {
				if (source[i].match(/[a-z]/)) {
					if (inCharRange) {
						pattern += source[i];
						pattern += `${source[i - 2]}-${source[i]}`.toUpperCase();
						inCharRange = false;
					} else if (source[i + 1] === "-" && source[i + 2]?.match(/[a-z]/)) {
						pattern += source[i];
						inCharRange = true;
					} else pattern += `${source[i]}${source[i].toUpperCase()}`;
					continue;
				}
			} else if (source[i].match(/[a-z]/)) {
				pattern += `[${source[i]}${source[i].toUpperCase()}]`;
				continue;
			}
		}
		if (flags.m) {
			if (source[i] === "^") {
				pattern += `(^|(?<=[\r\n]))`;
				continue;
			} else if (source[i] === "$") {
				pattern += `($|(?=[\r\n]))`;
				continue;
			}
		}
		if (flags.s && source[i] === ".") {
			pattern += inCharGroup ? `${source[i]}\r\n` : `[${source[i]}\r\n]`;
			continue;
		}
		pattern += source[i];
		if (source[i] === "\\") isEscaped = true;
		else if (inCharGroup && source[i] === "]") inCharGroup = false;
		else if (!inCharGroup && source[i] === "[") inCharGroup = true;
	}
	try {
		new RegExp(pattern);
	} catch {
		console.warn(`Could not convert regex pattern at ${refs.currentPath.join("/")} to a flag-independent form! Falling back to the flag-ignorant source`);
		return regex.source;
	}
	return pattern;
}
function parseRecordDef(def, refs) {
	if (refs.target === "openAi") console.warn("Warning: OpenAI may not support records in schemas! Try an array of key-value pairs instead.");
	if (refs.target === "openApi3" && def.keyType?._def.typeName === ZodFirstPartyTypeKind.ZodEnum) return {
		type: "object",
		required: def.keyType._def.values,
		properties: def.keyType._def.values.reduce((acc, key) => ({
			...acc,
			[key]: parseDef(def.valueType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"properties",
					key
				]
			}) ?? parseAnyDef(refs)
		}), {}),
		additionalProperties: refs.rejectedAdditionalProperties
	};
	const schema = {
		type: "object",
		additionalProperties: parseDef(def.valueType._def, {
			...refs,
			currentPath: [...refs.currentPath, "additionalProperties"]
		}) ?? refs.allowedAdditionalProperties
	};
	if (refs.target === "openApi3") return schema;
	if (def.keyType?._def.typeName === ZodFirstPartyTypeKind.ZodString && def.keyType._def.checks?.length) {
		const { type, ...keyType } = parseStringDef(def.keyType._def, refs);
		return {
			...schema,
			propertyNames: keyType
		};
	} else if (def.keyType?._def.typeName === ZodFirstPartyTypeKind.ZodEnum) return {
		...schema,
		propertyNames: { enum: def.keyType._def.values }
	};
	else if (def.keyType?._def.typeName === ZodFirstPartyTypeKind.ZodBranded && def.keyType._def.type._def.typeName === ZodFirstPartyTypeKind.ZodString && def.keyType._def.type._def.checks?.length) {
		const { type, ...keyType } = parseBrandedDef(def.keyType._def, refs);
		return {
			...schema,
			propertyNames: keyType
		};
	}
	return schema;
}
function parseMapDef(def, refs) {
	if (refs.mapStrategy === "record") return parseRecordDef(def, refs);
	return {
		type: "array",
		maxItems: 125,
		items: {
			type: "array",
			items: [parseDef(def.keyType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"items",
					"items",
					"0"
				]
			}) || parseAnyDef(refs), parseDef(def.valueType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"items",
					"items",
					"1"
				]
			}) || parseAnyDef(refs)],
			minItems: 2,
			maxItems: 2
		}
	};
}
function parseNativeEnumDef(def) {
	const object = def.values;
	const actualValues = Object.keys(def.values).filter((key) => {
		return typeof object[object[key]] !== "number";
	}).map((key) => object[key]);
	const parsedTypes = Array.from(new Set(actualValues.map((values) => typeof values)));
	return {
		type: parsedTypes.length === 1 ? parsedTypes[0] === "string" ? "string" : "number" : ["string", "number"],
		enum: actualValues
	};
}
function parseNeverDef(refs) {
	return refs.target === "openAi" ? void 0 : { not: parseAnyDef({
		...refs,
		currentPath: [...refs.currentPath, "not"]
	}) };
}
function parseNullDef(refs) {
	return refs.target === "openApi3" ? {
		enum: ["null"],
		nullable: true
	} : { type: "null" };
}
const primitiveMappings = {
	ZodString: "string",
	ZodNumber: "number",
	ZodBigInt: "integer",
	ZodBoolean: "boolean",
	ZodNull: "null"
};
function parseUnionDef(def, refs) {
	if (refs.target === "openApi3") return asAnyOf(def, refs);
	const options = def.options instanceof Map ? Array.from(def.options.values()) : def.options;
	if (options.every((x) => x._def.typeName in primitiveMappings && (!x._def.checks || !x._def.checks.length))) {
		const types = options.reduce((types, x) => {
			const type = primitiveMappings[x._def.typeName];
			return type && !types.includes(type) ? [...types, type] : types;
		}, []);
		return { type: types.length > 1 ? types : types[0] };
	} else if (options.every((x) => x._def.typeName === "ZodLiteral" && !x.description)) {
		const types = options.reduce((acc, x) => {
			const type = typeof x._def.value;
			switch (type) {
				case "string":
				case "number":
				case "boolean": return [...acc, type];
				case "bigint": return [...acc, "integer"];
				case "object": if (x._def.value === null) return [...acc, "null"];
				default: return acc;
			}
		}, []);
		if (types.length === options.length) {
			const uniqueTypes = types.filter((x, i, a) => a.indexOf(x) === i);
			return {
				type: uniqueTypes.length > 1 ? uniqueTypes : uniqueTypes[0],
				enum: options.reduce((acc, x) => {
					return acc.includes(x._def.value) ? acc : [...acc, x._def.value];
				}, [])
			};
		}
	} else if (options.every((x) => x._def.typeName === "ZodEnum")) return {
		type: "string",
		enum: options.reduce((acc, x) => [...acc, ...x._def.values.filter((x) => !acc.includes(x))], [])
	};
	return asAnyOf(def, refs);
}
const asAnyOf = (def, refs) => {
	const anyOf = (def.options instanceof Map ? Array.from(def.options.values()) : def.options).map((x, i) => parseDef(x._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			`${i}`
		]
	})).filter((x) => !!x && (!refs.strictUnions || typeof x === "object" && Object.keys(x).length > 0));
	return anyOf.length ? { anyOf } : void 0;
};
function parseNullableDef(def, refs) {
	if ([
		"ZodString",
		"ZodNumber",
		"ZodBigInt",
		"ZodBoolean",
		"ZodNull"
	].includes(def.innerType._def.typeName) && (!def.innerType._def.checks || !def.innerType._def.checks.length)) {
		if (refs.target === "openApi3") return {
			type: primitiveMappings[def.innerType._def.typeName],
			nullable: true
		};
		return { type: [primitiveMappings[def.innerType._def.typeName], "null"] };
	}
	if (refs.target === "openApi3") {
		const base = parseDef(def.innerType._def, {
			...refs,
			currentPath: [...refs.currentPath]
		});
		if (base && "$ref" in base) return {
			allOf: [base],
			nullable: true
		};
		return base && {
			...base,
			nullable: true
		};
	}
	const base = parseDef(def.innerType._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			"0"
		]
	});
	return base && { anyOf: [base, { type: "null" }] };
}
function parseNumberDef(def, refs) {
	const res = { type: "number" };
	if (!def.checks) return res;
	for (const check of def.checks) switch (check.kind) {
		case "int":
			res.type = "integer";
			addErrorMessage(res, "type", check.message, refs);
			break;
		case "min":
			if (refs.target === "jsonSchema7") if (check.inclusive) setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			else setResponseValueAndErrors(res, "exclusiveMinimum", check.value, check.message, refs);
			else {
				if (!check.inclusive) res.exclusiveMinimum = true;
				setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			}
			break;
		case "max":
			if (refs.target === "jsonSchema7") if (check.inclusive) setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			else setResponseValueAndErrors(res, "exclusiveMaximum", check.value, check.message, refs);
			else {
				if (!check.inclusive) res.exclusiveMaximum = true;
				setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			}
			break;
		case "multipleOf":
			setResponseValueAndErrors(res, "multipleOf", check.value, check.message, refs);
			break;
	}
	return res;
}
function parseObjectDef(def, refs) {
	const forceOptionalIntoNullable = refs.target === "openAi";
	const result = {
		type: "object",
		properties: {}
	};
	const required = [];
	const shape = def.shape();
	for (const propName in shape) {
		let propDef = shape[propName];
		if (propDef === void 0 || propDef._def === void 0) continue;
		let propOptional = safeIsOptional(propDef);
		if (propOptional && forceOptionalIntoNullable) {
			if (propDef._def.typeName === "ZodOptional") propDef = propDef._def.innerType;
			if (!propDef.isNullable()) propDef = propDef.nullable();
			propOptional = false;
		}
		const parsedDef = parseDef(propDef._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"properties",
				propName
			],
			propertyPath: [
				...refs.currentPath,
				"properties",
				propName
			]
		});
		if (parsedDef === void 0) continue;
		result.properties[propName] = parsedDef;
		if (!propOptional) required.push(propName);
	}
	if (required.length) result.required = required;
	const additionalProperties = decideAdditionalProperties(def, refs);
	if (additionalProperties !== void 0) result.additionalProperties = additionalProperties;
	return result;
}
function decideAdditionalProperties(def, refs) {
	if (def.catchall._def.typeName !== "ZodNever") return parseDef(def.catchall._def, {
		...refs,
		currentPath: [...refs.currentPath, "additionalProperties"]
	});
	switch (def.unknownKeys) {
		case "passthrough": return refs.allowedAdditionalProperties;
		case "strict": return refs.rejectedAdditionalProperties;
		case "strip": return refs.removeAdditionalStrategy === "strict" ? refs.allowedAdditionalProperties : refs.rejectedAdditionalProperties;
	}
}
function safeIsOptional(schema) {
	try {
		return schema.isOptional();
	} catch {
		return true;
	}
}
const parseOptionalDef = (def, refs) => {
	if (refs.currentPath.toString() === refs.propertyPath?.toString()) return parseDef(def.innerType._def, refs);
	const innerSchema = parseDef(def.innerType._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			"1"
		]
	});
	return innerSchema ? { anyOf: [{ not: parseAnyDef(refs) }, innerSchema] } : parseAnyDef(refs);
};
const parsePipelineDef = (def, refs) => {
	if (refs.pipeStrategy === "input") return parseDef(def.in._def, refs);
	else if (refs.pipeStrategy === "output") return parseDef(def.out._def, refs);
	const a = parseDef(def.in._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"0"
		]
	});
	return { allOf: [a, parseDef(def.out._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			a ? "1" : "0"
		]
	})].filter((x) => x !== void 0) };
};
function parsePromiseDef(def, refs) {
	return parseDef(def.type._def, refs);
}
function parseSetDef(def, refs) {
	const schema = {
		type: "array",
		uniqueItems: true,
		items: parseDef(def.valueType._def, {
			...refs,
			currentPath: [...refs.currentPath, "items"]
		})
	};
	if (def.minSize) setResponseValueAndErrors(schema, "minItems", def.minSize.value, def.minSize.message, refs);
	if (def.maxSize) setResponseValueAndErrors(schema, "maxItems", def.maxSize.value, def.maxSize.message, refs);
	return schema;
}
function parseTupleDef(def, refs) {
	if (def.rest) return {
		type: "array",
		minItems: def.items.length,
		items: def.items.map((x, i) => parseDef(x._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"items",
				`${i}`
			]
		})).reduce((acc, x) => x === void 0 ? acc : [...acc, x], []),
		additionalItems: parseDef(def.rest._def, {
			...refs,
			currentPath: [...refs.currentPath, "additionalItems"]
		})
	};
	else return {
		type: "array",
		minItems: def.items.length,
		maxItems: def.items.length,
		items: def.items.map((x, i) => parseDef(x._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"items",
				`${i}`
			]
		})).reduce((acc, x) => x === void 0 ? acc : [...acc, x], [])
	};
}
function parseUndefinedDef(refs) {
	return { not: parseAnyDef(refs) };
}
function parseUnknownDef(refs) {
	return parseAnyDef(refs);
}
const parseReadonlyDef = (def, refs) => {
	return parseDef(def.innerType._def, refs);
};
const selectParser = (def, typeName, refs) => {
	switch (typeName) {
		case ZodFirstPartyTypeKind.ZodString: return parseStringDef(def, refs);
		case ZodFirstPartyTypeKind.ZodNumber: return parseNumberDef(def, refs);
		case ZodFirstPartyTypeKind.ZodObject: return parseObjectDef(def, refs);
		case ZodFirstPartyTypeKind.ZodBigInt: return parseBigintDef(def, refs);
		case ZodFirstPartyTypeKind.ZodBoolean: return parseBooleanDef();
		case ZodFirstPartyTypeKind.ZodDate: return parseDateDef(def, refs);
		case ZodFirstPartyTypeKind.ZodUndefined: return parseUndefinedDef(refs);
		case ZodFirstPartyTypeKind.ZodNull: return parseNullDef(refs);
		case ZodFirstPartyTypeKind.ZodArray: return parseArrayDef(def, refs);
		case ZodFirstPartyTypeKind.ZodUnion:
		case ZodFirstPartyTypeKind.ZodDiscriminatedUnion: return parseUnionDef(def, refs);
		case ZodFirstPartyTypeKind.ZodIntersection: return parseIntersectionDef(def, refs);
		case ZodFirstPartyTypeKind.ZodTuple: return parseTupleDef(def, refs);
		case ZodFirstPartyTypeKind.ZodRecord: return parseRecordDef(def, refs);
		case ZodFirstPartyTypeKind.ZodLiteral: return parseLiteralDef(def, refs);
		case ZodFirstPartyTypeKind.ZodEnum: return parseEnumDef(def);
		case ZodFirstPartyTypeKind.ZodNativeEnum: return parseNativeEnumDef(def);
		case ZodFirstPartyTypeKind.ZodNullable: return parseNullableDef(def, refs);
		case ZodFirstPartyTypeKind.ZodOptional: return parseOptionalDef(def, refs);
		case ZodFirstPartyTypeKind.ZodMap: return parseMapDef(def, refs);
		case ZodFirstPartyTypeKind.ZodSet: return parseSetDef(def, refs);
		case ZodFirstPartyTypeKind.ZodLazy: return () => def.getter()._def;
		case ZodFirstPartyTypeKind.ZodPromise: return parsePromiseDef(def, refs);
		case ZodFirstPartyTypeKind.ZodNaN:
		case ZodFirstPartyTypeKind.ZodNever: return parseNeverDef(refs);
		case ZodFirstPartyTypeKind.ZodEffects: return parseEffectsDef(def, refs);
		case ZodFirstPartyTypeKind.ZodAny: return parseAnyDef(refs);
		case ZodFirstPartyTypeKind.ZodUnknown: return parseUnknownDef(refs);
		case ZodFirstPartyTypeKind.ZodDefault: return parseDefaultDef(def, refs);
		case ZodFirstPartyTypeKind.ZodBranded: return parseBrandedDef(def, refs);
		case ZodFirstPartyTypeKind.ZodReadonly: return parseReadonlyDef(def, refs);
		case ZodFirstPartyTypeKind.ZodCatch: return parseCatchDef(def, refs);
		case ZodFirstPartyTypeKind.ZodPipeline: return parsePipelineDef(def, refs);
		case ZodFirstPartyTypeKind.ZodFunction:
		case ZodFirstPartyTypeKind.ZodVoid:
		case ZodFirstPartyTypeKind.ZodSymbol: return;
		default: return ((_) => void 0)(typeName);
	}
};
function parseDef(def, refs, forceResolution = false) {
	const seenItem = refs.seen.get(def);
	if (refs.override) {
		const overrideResult = refs.override?.(def, refs, seenItem, forceResolution);
		if (overrideResult !== ignoreOverride) return overrideResult;
	}
	if (seenItem && !forceResolution) {
		const seenSchema = get$ref(seenItem, refs);
		if (seenSchema !== void 0) return seenSchema;
	}
	const newItem = {
		def,
		path: refs.currentPath,
		jsonSchema: void 0
	};
	refs.seen.set(def, newItem);
	const jsonSchemaOrGetter = selectParser(def, def.typeName, refs);
	const jsonSchema = typeof jsonSchemaOrGetter === "function" ? parseDef(jsonSchemaOrGetter(), refs) : jsonSchemaOrGetter;
	if (jsonSchema) addMeta(def, refs, jsonSchema);
	if (refs.postProcess) {
		const postProcessResult = refs.postProcess(jsonSchema, def, refs);
		newItem.jsonSchema = jsonSchema;
		return postProcessResult;
	}
	newItem.jsonSchema = jsonSchema;
	return jsonSchema;
}
const get$ref = (item, refs) => {
	switch (refs.$refStrategy) {
		case "root": return { $ref: item.path.join("/") };
		case "relative": return { $ref: getRelativePath(refs.currentPath, item.path) };
		case "none":
		case "seen":
			if (item.path.length < refs.currentPath.length && item.path.every((value, index) => refs.currentPath[index] === value)) {
				console.warn(`Recursive reference detected at ${refs.currentPath.join("/")}! Defaulting to any`);
				return parseAnyDef(refs);
			}
			return refs.$refStrategy === "seen" ? parseAnyDef(refs) : void 0;
	}
};
const addMeta = (def, refs, jsonSchema) => {
	if (def.description) {
		jsonSchema.description = def.description;
		if (refs.markdownDescription) jsonSchema.markdownDescription = def.description;
	}
	return jsonSchema;
};
const zodToJsonSchema = (schema, options) => {
	const refs = getRefs(options);
	let definitions = typeof options === "object" && options.definitions ? Object.entries(options.definitions).reduce((acc, [name, schema]) => ({
		...acc,
		[name]: parseDef(schema._def, {
			...refs,
			currentPath: [
				...refs.basePath,
				refs.definitionPath,
				name
			]
		}, true) ?? parseAnyDef(refs)
	}), {}) : void 0;
	const name = typeof options === "string" ? options : options?.nameStrategy === "title" ? void 0 : options?.name;
	const main = parseDef(schema._def, name === void 0 ? refs : {
		...refs,
		currentPath: [
			...refs.basePath,
			refs.definitionPath,
			name
		]
	}, false) ?? parseAnyDef(refs);
	const title = typeof options === "object" && options.name !== void 0 && options.nameStrategy === "title" ? options.name : void 0;
	if (title !== void 0) main.title = title;
	if (refs.flags.hasReferencedOpenAiAnyType) {
		if (!definitions) definitions = {};
		if (!definitions[refs.openAiAnyTypeName]) definitions[refs.openAiAnyTypeName] = {
			type: [
				"string",
				"number",
				"integer",
				"boolean",
				"array",
				"null"
			],
			items: { $ref: refs.$refStrategy === "relative" ? "1" : [
				...refs.basePath,
				refs.definitionPath,
				refs.openAiAnyTypeName
			].join("/") }
		};
	}
	const combined = name === void 0 ? definitions ? {
		...main,
		[refs.definitionPath]: definitions
	} : main : {
		$ref: [
			...refs.$refStrategy === "relative" ? [] : refs.basePath,
			refs.definitionPath,
			name
		].join("/"),
		[refs.definitionPath]: {
			...definitions,
			[name]: main
		}
	};
	if (refs.target === "jsonSchema7") combined.$schema = "http://json-schema.org/draft-07/schema#";
	else if (refs.target === "jsonSchema2019-09" || refs.target === "openAi") combined.$schema = "https://json-schema.org/draft/2019-09/schema#";
	if (refs.target === "openAi" && ("anyOf" in combined || "oneOf" in combined || "allOf" in combined || "type" in combined && Array.isArray(combined.type))) console.warn("Warning: OpenAI may not support schemas with unions as roots! Try wrapping it in an object property.");
	return combined;
};
var esm_default = zodToJsonSchema;
var textStreamPart = {
	code: "0",
	name: "text",
	parse: (value) => {
		if (typeof value !== "string") throw new Error("\"text\" parts expect a string value.");
		return {
			type: "text",
			value
		};
	}
};
var errorStreamPart = {
	code: "3",
	name: "error",
	parse: (value) => {
		if (typeof value !== "string") throw new Error("\"error\" parts expect a string value.");
		return {
			type: "error",
			value
		};
	}
};
var assistantMessageStreamPart = {
	code: "4",
	name: "assistant_message",
	parse: (value) => {
		if (value == null || typeof value !== "object" || !("id" in value) || !("role" in value) || !("content" in value) || typeof value.id !== "string" || typeof value.role !== "string" || value.role !== "assistant" || !Array.isArray(value.content) || !value.content.every((item) => item != null && typeof item === "object" && "type" in item && item.type === "text" && "text" in item && item.text != null && typeof item.text === "object" && "value" in item.text && typeof item.text.value === "string")) throw new Error("\"assistant_message\" parts expect an object with an \"id\", \"role\", and \"content\" property.");
		return {
			type: "assistant_message",
			value
		};
	}
};
var assistantControlDataStreamPart = {
	code: "5",
	name: "assistant_control_data",
	parse: (value) => {
		if (value == null || typeof value !== "object" || !("threadId" in value) || !("messageId" in value) || typeof value.threadId !== "string" || typeof value.messageId !== "string") throw new Error("\"assistant_control_data\" parts expect an object with a \"threadId\" and \"messageId\" property.");
		return {
			type: "assistant_control_data",
			value: {
				threadId: value.threadId,
				messageId: value.messageId
			}
		};
	}
};
var dataMessageStreamPart = {
	code: "6",
	name: "data_message",
	parse: (value) => {
		if (value == null || typeof value !== "object" || !("role" in value) || !("data" in value) || typeof value.role !== "string" || value.role !== "data") throw new Error("\"data_message\" parts expect an object with a \"role\" and \"data\" property.");
		return {
			type: "data_message",
			value
		};
	}
};
var assistantStreamParts = [
	textStreamPart,
	errorStreamPart,
	assistantMessageStreamPart,
	assistantControlDataStreamPart,
	dataMessageStreamPart
];
textStreamPart.code, errorStreamPart.code, assistantMessageStreamPart.code, assistantControlDataStreamPart.code, dataMessageStreamPart.code;
textStreamPart.name, textStreamPart.code, errorStreamPart.name, errorStreamPart.code, assistantMessageStreamPart.name, assistantMessageStreamPart.code, assistantControlDataStreamPart.name, assistantControlDataStreamPart.code, dataMessageStreamPart.name, dataMessageStreamPart.code;
assistantStreamParts.map((part) => part.code);
function fixJson(input) {
	const stack = ["ROOT"];
	let lastValidIndex = -1;
	let literalStart = null;
	function processValueStart(char, i, swapState) {
		switch (char) {
			case "\"":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_STRING");
				break;
			case "f":
			case "t":
			case "n":
				lastValidIndex = i;
				literalStart = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_LITERAL");
				break;
			case "-":
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "0":
			case "1":
			case "2":
			case "3":
			case "4":
			case "5":
			case "6":
			case "7":
			case "8":
			case "9":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "{":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_OBJECT_START");
				break;
			case "[":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_ARRAY_START");
				break;
		}
	}
	function processAfterObjectValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_OBJECT_AFTER_COMMA");
				break;
			case "}":
				lastValidIndex = i;
				stack.pop();
				break;
		}
	}
	function processAfterArrayValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_ARRAY_AFTER_COMMA");
				break;
			case "]":
				lastValidIndex = i;
				stack.pop();
				break;
		}
	}
	for (let i = 0; i < input.length; i++) {
		const char = input[i];
		switch (stack[stack.length - 1]) {
			case "ROOT":
				processValueStart(char, i, "FINISH");
				break;
			case "INSIDE_OBJECT_START":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
					case "}":
						lastValidIndex = i;
						stack.pop();
						break;
				}
				break;
			case "INSIDE_OBJECT_AFTER_COMMA":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
				}
				break;
			case "INSIDE_OBJECT_KEY":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_AFTER_KEY");
						break;
				}
				break;
			case "INSIDE_OBJECT_AFTER_KEY":
				switch (char) {
					case ":":
						stack.pop();
						stack.push("INSIDE_OBJECT_BEFORE_VALUE");
						break;
				}
				break;
			case "INSIDE_OBJECT_BEFORE_VALUE":
				processValueStart(char, i, "INSIDE_OBJECT_AFTER_VALUE");
				break;
			case "INSIDE_OBJECT_AFTER_VALUE":
				processAfterObjectValue(char, i);
				break;
			case "INSIDE_STRING":
				switch (char) {
					case "\"":
						stack.pop();
						lastValidIndex = i;
						break;
					case "\\":
						stack.push("INSIDE_STRING_ESCAPE");
						break;
					default: lastValidIndex = i;
				}
				break;
			case "INSIDE_ARRAY_START":
				switch (char) {
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
						break;
				}
				break;
			case "INSIDE_ARRAY_AFTER_VALUE":
				switch (char) {
					case ",":
						stack.pop();
						stack.push("INSIDE_ARRAY_AFTER_COMMA");
						break;
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						break;
				}
				break;
			case "INSIDE_ARRAY_AFTER_COMMA":
				processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
				break;
			case "INSIDE_STRING_ESCAPE":
				stack.pop();
				lastValidIndex = i;
				break;
			case "INSIDE_NUMBER":
				switch (char) {
					case "0":
					case "1":
					case "2":
					case "3":
					case "4":
					case "5":
					case "6":
					case "7":
					case "8":
					case "9":
						lastValidIndex = i;
						break;
					case "e":
					case "E":
					case "-":
					case ".": break;
					case ",":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "}":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "]":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						break;
					default:
						stack.pop();
						break;
				}
				break;
			case "INSIDE_LITERAL": {
				const partialLiteral = input.substring(literalStart, i + 1);
				if (!"false".startsWith(partialLiteral) && !"true".startsWith(partialLiteral) && !"null".startsWith(partialLiteral)) {
					stack.pop();
					if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
					else if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
				} else lastValidIndex = i;
				break;
			}
		}
	}
	let result = input.slice(0, lastValidIndex + 1);
	for (let i = stack.length - 1; i >= 0; i--) switch (stack[i]) {
		case "INSIDE_STRING":
			result += "\"";
			break;
		case "INSIDE_OBJECT_KEY":
		case "INSIDE_OBJECT_AFTER_KEY":
		case "INSIDE_OBJECT_AFTER_COMMA":
		case "INSIDE_OBJECT_START":
		case "INSIDE_OBJECT_BEFORE_VALUE":
		case "INSIDE_OBJECT_AFTER_VALUE":
			result += "}";
			break;
		case "INSIDE_ARRAY_START":
		case "INSIDE_ARRAY_AFTER_COMMA":
		case "INSIDE_ARRAY_AFTER_VALUE":
			result += "]";
			break;
		case "INSIDE_LITERAL": {
			const partialLiteral = input.substring(literalStart, input.length);
			if ("true".startsWith(partialLiteral)) result += "true".slice(partialLiteral.length);
			else if ("false".startsWith(partialLiteral)) result += "false".slice(partialLiteral.length);
			else if ("null".startsWith(partialLiteral)) result += "null".slice(partialLiteral.length);
		}
	}
	return result;
}
function parsePartialJson(jsonText) {
	if (jsonText === void 0) return {
		value: void 0,
		state: "undefined-input"
	};
	let result = safeParseJSON({ text: jsonText });
	if (result.success) return {
		value: result.value,
		state: "successful-parse"
	};
	result = safeParseJSON({ text: fixJson(jsonText) });
	if (result.success) return {
		value: result.value,
		state: "repaired-parse"
	};
	return {
		value: void 0,
		state: "failed-parse"
	};
}
var dataStreamParts = [
	{
		code: "0",
		name: "text",
		parse: (value) => {
			if (typeof value !== "string") throw new Error("\"text\" parts expect a string value.");
			return {
				type: "text",
				value
			};
		}
	},
	{
		code: "2",
		name: "data",
		parse: (value) => {
			if (!Array.isArray(value)) throw new Error("\"data\" parts expect an array value.");
			return {
				type: "data",
				value
			};
		}
	},
	{
		code: "3",
		name: "error",
		parse: (value) => {
			if (typeof value !== "string") throw new Error("\"error\" parts expect a string value.");
			return {
				type: "error",
				value
			};
		}
	},
	{
		code: "8",
		name: "message_annotations",
		parse: (value) => {
			if (!Array.isArray(value)) throw new Error("\"message_annotations\" parts expect an array value.");
			return {
				type: "message_annotations",
				value
			};
		}
	},
	{
		code: "9",
		name: "tool_call",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("toolName" in value) || typeof value.toolName !== "string" || !("args" in value) || typeof value.args !== "object") throw new Error("\"tool_call\" parts expect an object with a \"toolCallId\", \"toolName\", and \"args\" property.");
			return {
				type: "tool_call",
				value
			};
		}
	},
	{
		code: "a",
		name: "tool_result",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("result" in value)) throw new Error("\"tool_result\" parts expect an object with a \"toolCallId\" and a \"result\" property.");
			return {
				type: "tool_result",
				value
			};
		}
	},
	{
		code: "b",
		name: "tool_call_streaming_start",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("toolName" in value) || typeof value.toolName !== "string") throw new Error("\"tool_call_streaming_start\" parts expect an object with a \"toolCallId\" and \"toolName\" property.");
			return {
				type: "tool_call_streaming_start",
				value
			};
		}
	},
	{
		code: "c",
		name: "tool_call_delta",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("argsTextDelta" in value) || typeof value.argsTextDelta !== "string") throw new Error("\"tool_call_delta\" parts expect an object with a \"toolCallId\" and \"argsTextDelta\" property.");
			return {
				type: "tool_call_delta",
				value
			};
		}
	},
	{
		code: "d",
		name: "finish_message",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("finishReason" in value) || typeof value.finishReason !== "string") throw new Error("\"finish_message\" parts expect an object with a \"finishReason\" property.");
			const result = { finishReason: value.finishReason };
			if ("usage" in value && value.usage != null && typeof value.usage === "object" && "promptTokens" in value.usage && "completionTokens" in value.usage) result.usage = {
				promptTokens: typeof value.usage.promptTokens === "number" ? value.usage.promptTokens : NaN,
				completionTokens: typeof value.usage.completionTokens === "number" ? value.usage.completionTokens : NaN
			};
			return {
				type: "finish_message",
				value: result
			};
		}
	},
	{
		code: "e",
		name: "finish_step",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("finishReason" in value) || typeof value.finishReason !== "string") throw new Error("\"finish_step\" parts expect an object with a \"finishReason\" property.");
			const result = {
				finishReason: value.finishReason,
				isContinued: false
			};
			if ("usage" in value && value.usage != null && typeof value.usage === "object" && "promptTokens" in value.usage && "completionTokens" in value.usage) result.usage = {
				promptTokens: typeof value.usage.promptTokens === "number" ? value.usage.promptTokens : NaN,
				completionTokens: typeof value.usage.completionTokens === "number" ? value.usage.completionTokens : NaN
			};
			if ("isContinued" in value && typeof value.isContinued === "boolean") result.isContinued = value.isContinued;
			return {
				type: "finish_step",
				value: result
			};
		}
	},
	{
		code: "f",
		name: "start_step",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("messageId" in value) || typeof value.messageId !== "string") throw new Error("\"start_step\" parts expect an object with an \"id\" property.");
			return {
				type: "start_step",
				value: { messageId: value.messageId }
			};
		}
	},
	{
		code: "g",
		name: "reasoning",
		parse: (value) => {
			if (typeof value !== "string") throw new Error("\"reasoning\" parts expect a string value.");
			return {
				type: "reasoning",
				value
			};
		}
	},
	{
		code: "h",
		name: "source",
		parse: (value) => {
			if (value == null || typeof value !== "object") throw new Error("\"source\" parts expect a Source object.");
			return {
				type: "source",
				value
			};
		}
	},
	{
		code: "i",
		name: "redacted_reasoning",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("data" in value) || typeof value.data !== "string") throw new Error("\"redacted_reasoning\" parts expect an object with a \"data\" property.");
			return {
				type: "redacted_reasoning",
				value: { data: value.data }
			};
		}
	},
	{
		code: "j",
		name: "reasoning_signature",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("signature" in value) || typeof value.signature !== "string") throw new Error("\"reasoning_signature\" parts expect an object with a \"signature\" property.");
			return {
				type: "reasoning_signature",
				value: { signature: value.signature }
			};
		}
	},
	{
		code: "k",
		name: "file",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("data" in value) || typeof value.data !== "string" || !("mimeType" in value) || typeof value.mimeType !== "string") throw new Error("\"file\" parts expect an object with a \"data\" and \"mimeType\" property.");
			return {
				type: "file",
				value
			};
		}
	}
];
Object.fromEntries(dataStreamParts.map((part) => [part.code, part]));
Object.fromEntries(dataStreamParts.map((part) => [part.name, part.code]));
dataStreamParts.map((part) => part.code);
function formatDataStreamPart(type, value) {
	const streamPart = dataStreamParts.find((part) => part.name === type);
	if (!streamPart) throw new Error(`Invalid stream part type: ${type}`);
	return `${streamPart.code}:${JSON.stringify(value)}
`;
}
"\n".charCodeAt(0);
"\n".charCodeAt(0);
function zodSchema(zodSchema2, options) {
	var _a;
	return jsonSchema(esm_default(zodSchema2, {
		$refStrategy: ((_a = options == null ? void 0 : options.useReferences) != null ? _a : false) ? "root" : "none",
		target: "jsonSchema7"
	}), { validate: (value) => {
		const result = zodSchema2.safeParse(value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	} });
}
var schemaSymbol = Symbol.for("vercel.ai.schema");
function jsonSchema(jsonSchema2, { validate } = {}) {
	return {
		[schemaSymbol]: true,
		_type: void 0,
		[validatorSymbol]: true,
		jsonSchema: jsonSchema2,
		validate
	};
}
function isSchema(value) {
	return typeof value === "object" && value !== null && schemaSymbol in value && value[schemaSymbol] === true && "jsonSchema" in value && "validate" in value;
}
function asSchema(schema) {
	return isSchema(schema) ? schema : zodSchema(schema);
}
/** only globals that common to node and browsers are allowed */
var _globalThis = typeof globalThis === "object" ? globalThis : global;
var VERSION = "1.9.0";
var re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
/**
* Create a function to test an API version to see if it is compatible with the provided ownVersion.
*
* The returned function has the following semantics:
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param ownVersion version which should be checked against
*/
function _makeCompatibilityCheck(ownVersion) {
	var acceptedVersions = /* @__PURE__ */ new Set([ownVersion]);
	var rejectedVersions = /* @__PURE__ */ new Set();
	var myVersionMatch = ownVersion.match(re);
	if (!myVersionMatch) return function() {
		return false;
	};
	var ownVersionParsed = {
		major: +myVersionMatch[1],
		minor: +myVersionMatch[2],
		patch: +myVersionMatch[3],
		prerelease: myVersionMatch[4]
	};
	if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
		return globalVersion === ownVersion;
	};
	function _reject(v) {
		rejectedVersions.add(v);
		return false;
	}
	function _accept(v) {
		acceptedVersions.add(v);
		return true;
	}
	return function isCompatible(globalVersion) {
		if (acceptedVersions.has(globalVersion)) return true;
		if (rejectedVersions.has(globalVersion)) return false;
		var globalVersionMatch = globalVersion.match(re);
		if (!globalVersionMatch) return _reject(globalVersion);
		var globalVersionParsed = {
			major: +globalVersionMatch[1],
			minor: +globalVersionMatch[2],
			patch: +globalVersionMatch[3],
			prerelease: globalVersionMatch[4]
		};
		if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
		if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
		if (ownVersionParsed.major === 0) {
			if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
			return _reject(globalVersion);
		}
		if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
		return _reject(globalVersion);
	};
}
/**
* Test an API version to see if it is compatible with this API.
*
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param version version of the API requesting an instance of the global API
*/
var isCompatible = _makeCompatibilityCheck(VERSION);
var major = VERSION.split(".")[0];
var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
var _global = _globalThis;
function registerGlobal(type, instance, diag, allowOverride) {
	var _a;
	if (allowOverride === void 0) allowOverride = false;
	var api = _global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : { version: VERSION };
	if (!allowOverride && api[type]) {
		var err = /* @__PURE__ */ new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
		diag.error(err.stack || err.message);
		return false;
	}
	if (api.version !== "1.9.0") {
		var err = /* @__PURE__ */ new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + VERSION);
		diag.error(err.stack || err.message);
		return false;
	}
	api[type] = instance;
	diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + VERSION + ".");
	return true;
}
function getGlobal(type) {
	var _a, _b;
	var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
	if (!globalVersion || !isCompatible(globalVersion)) return;
	return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
	diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + VERSION + ".");
	var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
	if (api) delete api[type];
}
var __read$3 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$3 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
/**
* Component Logger which is meant to be used as part of any component which
* will add automatically additional namespace in front of the log message.
* It will then forward all message to global diag logger
* @example
* const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
* cLogger.debug('test');
* // @opentelemetry/instrumentation-http test
*/
var DiagComponentLogger = function() {
	function DiagComponentLogger(props) {
		this._namespace = props.namespace || "DiagComponentLogger";
	}
	DiagComponentLogger.prototype.debug = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("debug", this._namespace, args);
	};
	DiagComponentLogger.prototype.error = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("error", this._namespace, args);
	};
	DiagComponentLogger.prototype.info = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("info", this._namespace, args);
	};
	DiagComponentLogger.prototype.warn = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("warn", this._namespace, args);
	};
	DiagComponentLogger.prototype.verbose = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("verbose", this._namespace, args);
	};
	return DiagComponentLogger;
}();
function logProxy(funcName, namespace, args) {
	var logger = getGlobal("diag");
	if (!logger) return;
	args.unshift(namespace);
	return logger[funcName].apply(logger, __spreadArray$3([], __read$3(args), false));
}
/**
* Defines the available internal logging levels for the diagnostic logger, the numeric values
* of the levels are defined to match the original values from the initial LogLevel to avoid
* compatibility/migration issues for any implementation that assume the numeric ordering.
*/
var DiagLogLevel;
(function(DiagLogLevel) {
	/** Diagnostic Logging level setting to disable all logging (except and forced logs) */
	DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
	/** Identifies an error scenario */
	DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
	/** Identifies a warning scenario */
	DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
	/** General informational log message */
	DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
	/** General debug log message */
	DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
	/**
	* Detailed trace level logging should only be used for development, should only be set
	* in a development environment.
	*/
	DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
	/** Used to set the logging level to include all logging */
	DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));
function createLogLevelDiagLogger(maxLevel, logger) {
	if (maxLevel < DiagLogLevel.NONE) maxLevel = DiagLogLevel.NONE;
	else if (maxLevel > DiagLogLevel.ALL) maxLevel = DiagLogLevel.ALL;
	logger = logger || {};
	function _filterFunc(funcName, theLevel) {
		var theFunc = logger[funcName];
		if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
		return function() {};
	}
	return {
		error: _filterFunc("error", DiagLogLevel.ERROR),
		warn: _filterFunc("warn", DiagLogLevel.WARN),
		info: _filterFunc("info", DiagLogLevel.INFO),
		debug: _filterFunc("debug", DiagLogLevel.DEBUG),
		verbose: _filterFunc("verbose", DiagLogLevel.VERBOSE)
	};
}
var __read$2 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$2 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$2 = "diag";
/**
* Singleton object which represents the entry point to the OpenTelemetry internal
* diagnostic API
*/
var DiagAPI = function() {
	/**
	* Private internal constructor
	* @private
	*/
	function DiagAPI() {
		function _logProxy(funcName) {
			return function() {
				var args = [];
				for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
				var logger = getGlobal("diag");
				if (!logger) return;
				return logger[funcName].apply(logger, __spreadArray$2([], __read$2(args), false));
			};
		}
		var self = this;
		var setLogger = function(logger, optionsOrLogLevel) {
			var _a, _b, _c;
			if (optionsOrLogLevel === void 0) optionsOrLogLevel = { logLevel: DiagLogLevel.INFO };
			if (logger === self) {
				var err = /* @__PURE__ */ new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
				self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
				return false;
			}
			if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = { logLevel: optionsOrLogLevel };
			var oldLogger = getGlobal("diag");
			var newLogger = createLogLevelDiagLogger((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : DiagLogLevel.INFO, logger);
			if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
				var stack = (_c = (/* @__PURE__ */ new Error()).stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
				oldLogger.warn("Current logger will be overwritten from " + stack);
				newLogger.warn("Current logger will overwrite one already registered from " + stack);
			}
			return registerGlobal("diag", newLogger, self, true);
		};
		self.setLogger = setLogger;
		self.disable = function() {
			unregisterGlobal(API_NAME$2, self);
		};
		self.createComponentLogger = function(options) {
			return new DiagComponentLogger(options);
		};
		self.verbose = _logProxy("verbose");
		self.debug = _logProxy("debug");
		self.info = _logProxy("info");
		self.warn = _logProxy("warn");
		self.error = _logProxy("error");
	}
	/** Get the singleton instance of the DiagAPI API */
	DiagAPI.instance = function() {
		if (!this._instance) this._instance = new DiagAPI();
		return this._instance;
	};
	return DiagAPI;
}();
/** Get a key to uniquely identify a context value */
function createContextKey(description) {
	return Symbol.for(description);
}
/** The root context is used as the default parent context when there is no active context */
var ROOT_CONTEXT = new (function() {
	/**
	* Construct a new context which inherits values from an optional parent context.
	*
	* @param parentContext a context from which to inherit values
	*/
	function BaseContext(parentContext) {
		var self = this;
		self._currentContext = parentContext ? new Map(parentContext) : /* @__PURE__ */ new Map();
		self.getValue = function(key) {
			return self._currentContext.get(key);
		};
		self.setValue = function(key, value) {
			var context = new BaseContext(self._currentContext);
			context._currentContext.set(key, value);
			return context;
		};
		self.deleteValue = function(key) {
			var context = new BaseContext(self._currentContext);
			context._currentContext.delete(key);
			return context;
		};
	}
	return BaseContext;
}())();
var __read$1 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$1 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var NoopContextManager = function() {
	function NoopContextManager() {}
	NoopContextManager.prototype.active = function() {
		return ROOT_CONTEXT;
	};
	NoopContextManager.prototype.with = function(_context, fn, thisArg) {
		var args = [];
		for (var _i = 3; _i < arguments.length; _i++) args[_i - 3] = arguments[_i];
		return fn.call.apply(fn, __spreadArray$1([thisArg], __read$1(args), false));
	};
	NoopContextManager.prototype.bind = function(_context, target) {
		return target;
	};
	NoopContextManager.prototype.enable = function() {
		return this;
	};
	NoopContextManager.prototype.disable = function() {
		return this;
	};
	return NoopContextManager;
}();
var __read = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$1 = "context";
var NOOP_CONTEXT_MANAGER = new NoopContextManager();
/**
* Singleton object which represents the entry point to the OpenTelemetry Context API
*/
var ContextAPI = function() {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	function ContextAPI() {}
	/** Get the singleton instance of the Context API */
	ContextAPI.getInstance = function() {
		if (!this._instance) this._instance = new ContextAPI();
		return this._instance;
	};
	/**
	* Set the current context manager.
	*
	* @returns true if the context manager was successfully registered, else false
	*/
	ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
		return registerGlobal(API_NAME$1, contextManager, DiagAPI.instance());
	};
	/**
	* Get the currently active context
	*/
	ContextAPI.prototype.active = function() {
		return this._getContextManager().active();
	};
	/**
	* Execute a function with an active context
	*
	* @param context context to be active during function execution
	* @param fn function to execute in a context
	* @param thisArg optional receiver to be used for calling fn
	* @param args optional arguments forwarded to fn
	*/
	ContextAPI.prototype.with = function(context, fn, thisArg) {
		var _a;
		var args = [];
		for (var _i = 3; _i < arguments.length; _i++) args[_i - 3] = arguments[_i];
		return (_a = this._getContextManager()).with.apply(_a, __spreadArray([
			context,
			fn,
			thisArg
		], __read(args), false));
	};
	/**
	* Bind a context to a target function or event emitter
	*
	* @param context context to bind to the event emitter or function. Defaults to the currently active context
	* @param target function or event emitter to bind
	*/
	ContextAPI.prototype.bind = function(context, target) {
		return this._getContextManager().bind(context, target);
	};
	ContextAPI.prototype._getContextManager = function() {
		return getGlobal(API_NAME$1) || NOOP_CONTEXT_MANAGER;
	};
	/** Disable and remove the global context manager */
	ContextAPI.prototype.disable = function() {
		this._getContextManager().disable();
		unregisterGlobal(API_NAME$1, DiagAPI.instance());
	};
	return ContextAPI;
}();
var TraceFlags;
(function(TraceFlags) {
	/** Represents no flag set. */
	TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
	/** Bit to represent whether trace is sampled in trace flags. */
	TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));
var INVALID_SPAN_CONTEXT = {
	traceId: "00000000000000000000000000000000",
	spanId: "0000000000000000",
	traceFlags: TraceFlags.NONE
};
/**
* The NonRecordingSpan is the default {@link Span} that is used when no Span
* implementation is available. All operations are no-op including context
* propagation.
*/
var NonRecordingSpan = function() {
	function NonRecordingSpan(_spanContext) {
		if (_spanContext === void 0) _spanContext = INVALID_SPAN_CONTEXT;
		this._spanContext = _spanContext;
	}
	NonRecordingSpan.prototype.spanContext = function() {
		return this._spanContext;
	};
	NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
		return this;
	};
	NonRecordingSpan.prototype.setAttributes = function(_attributes) {
		return this;
	};
	NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
		return this;
	};
	NonRecordingSpan.prototype.addLink = function(_link) {
		return this;
	};
	NonRecordingSpan.prototype.addLinks = function(_links) {
		return this;
	};
	NonRecordingSpan.prototype.setStatus = function(_status) {
		return this;
	};
	NonRecordingSpan.prototype.updateName = function(_name) {
		return this;
	};
	NonRecordingSpan.prototype.end = function(_endTime) {};
	NonRecordingSpan.prototype.isRecording = function() {
		return false;
	};
	NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
	return NonRecordingSpan;
}();
/**
* span key
*/
var SPAN_KEY = createContextKey("OpenTelemetry Context Key SPAN");
/**
* Return the span if one exists
*
* @param context context to get span from
*/
function getSpan(context) {
	return context.getValue(SPAN_KEY) || void 0;
}
/**
* Gets the span from the current context, if one exists.
*/
function getActiveSpan() {
	return getSpan(ContextAPI.getInstance().active());
}
/**
* Set the span on a context
*
* @param context context to use as parent
* @param span span to set active
*/
function setSpan(context, span) {
	return context.setValue(SPAN_KEY, span);
}
/**
* Remove current span stored in the context
*
* @param context context to delete span from
*/
function deleteSpan(context) {
	return context.deleteValue(SPAN_KEY);
}
/**
* Wrap span context in a NoopSpan and set as span in a new
* context
*
* @param context context to set active span on
* @param spanContext span context to be wrapped
*/
function setSpanContext(context, spanContext) {
	return setSpan(context, new NonRecordingSpan(spanContext));
}
/**
* Get the span context of the span if it exists.
*
* @param context context to get values from
*/
function getSpanContext(context) {
	var _a;
	return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}
var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId(traceId) {
	return VALID_TRACEID_REGEX.test(traceId) && traceId !== "00000000000000000000000000000000";
}
function isValidSpanId(spanId) {
	return VALID_SPANID_REGEX.test(spanId) && spanId !== "0000000000000000";
}
/**
* Returns true if this {@link SpanContext} is valid.
* @return true if this {@link SpanContext} is valid.
*/
function isSpanContextValid(spanContext) {
	return isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId);
}
/**
* Wrap the given {@link SpanContext} in a new non-recording {@link Span}
*
* @param spanContext span context to be wrapped
* @returns a new non-recording {@link Span} with the provided context
*/
function wrapSpanContext(spanContext) {
	return new NonRecordingSpan(spanContext);
}
var contextApi = ContextAPI.getInstance();
/**
* No-op implementations of {@link Tracer}.
*/
var NoopTracer = function() {
	function NoopTracer() {}
	NoopTracer.prototype.startSpan = function(name, options, context) {
		if (context === void 0) context = contextApi.active();
		if (Boolean(options === null || options === void 0 ? void 0 : options.root)) return new NonRecordingSpan();
		var parentFromContext = context && getSpanContext(context);
		if (isSpanContext(parentFromContext) && isSpanContextValid(parentFromContext)) return new NonRecordingSpan(parentFromContext);
		else return new NonRecordingSpan();
	};
	NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
		var opts;
		var ctx;
		var fn;
		if (arguments.length < 2) return;
		else if (arguments.length === 2) fn = arg2;
		else if (arguments.length === 3) {
			opts = arg2;
			fn = arg3;
		} else {
			opts = arg2;
			ctx = arg3;
			fn = arg4;
		}
		var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
		var span = this.startSpan(name, opts, parentContext);
		var contextWithSpanSet = setSpan(parentContext, span);
		return contextApi.with(contextWithSpanSet, fn, void 0, span);
	};
	return NoopTracer;
}();
function isSpanContext(spanContext) {
	return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
}
var NOOP_TRACER = new NoopTracer();
/**
* Proxy tracer provided by the proxy tracer provider
*/
var ProxyTracer = function() {
	function ProxyTracer(_provider, name, version, options) {
		this._provider = _provider;
		this.name = name;
		this.version = version;
		this.options = options;
	}
	ProxyTracer.prototype.startSpan = function(name, options, context) {
		return this._getTracer().startSpan(name, options, context);
	};
	ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
		var tracer = this._getTracer();
		return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
	};
	/**
	* Try to get a tracer from the proxy tracer provider.
	* If the proxy tracer provider has no delegate, return a noop tracer.
	*/
	ProxyTracer.prototype._getTracer = function() {
		if (this._delegate) return this._delegate;
		var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
		if (!tracer) return NOOP_TRACER;
		this._delegate = tracer;
		return this._delegate;
	};
	return ProxyTracer;
}();
var NOOP_TRACER_PROVIDER = new (function() {
	function NoopTracerProvider() {}
	NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
		return new NoopTracer();
	};
	return NoopTracerProvider;
}())();
/**
* Tracer provider which provides {@link ProxyTracer}s.
*
* Before a delegate is set, tracers provided are NoOp.
*   When a delegate is set, traces are provided from the delegate.
*   When a delegate is set after tracers have already been provided,
*   all tracers already provided will use the provided delegate implementation.
*/
var ProxyTracerProvider = function() {
	function ProxyTracerProvider() {}
	/**
	* Get a {@link ProxyTracer}
	*/
	ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
		var _a;
		return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new ProxyTracer(this, name, version, options);
	};
	ProxyTracerProvider.prototype.getDelegate = function() {
		var _a;
		return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
	};
	/**
	* Set the delegate tracer provider
	*/
	ProxyTracerProvider.prototype.setDelegate = function(delegate) {
		this._delegate = delegate;
	};
	ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
		var _a;
		return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
	};
	return ProxyTracerProvider;
}();
/**
* An enumeration of status codes.
*/
var SpanStatusCode;
(function(SpanStatusCode) {
	/**
	* The default status.
	*/
	SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
	/**
	* The operation has been validated by an Application developer or
	* Operator to have completed successfully.
	*/
	SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
	/**
	* The operation contains an error.
	*/
	SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode || (SpanStatusCode = {}));
var API_NAME = "trace";
(function() {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	function TraceAPI() {
		this._proxyTracerProvider = new ProxyTracerProvider();
		this.wrapSpanContext = wrapSpanContext;
		this.isSpanContextValid = isSpanContextValid;
		this.deleteSpan = deleteSpan;
		this.getSpan = getSpan;
		this.getActiveSpan = getActiveSpan;
		this.getSpanContext = getSpanContext;
		this.setSpan = setSpan;
		this.setSpanContext = setSpanContext;
	}
	/** Get the singleton instance of the Trace API */
	TraceAPI.getInstance = function() {
		if (!this._instance) this._instance = new TraceAPI();
		return this._instance;
	};
	/**
	* Set the current global tracer.
	*
	* @returns true if the tracer provider was successfully registered, else false
	*/
	TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
		var success = registerGlobal(API_NAME, this._proxyTracerProvider, DiagAPI.instance());
		if (success) this._proxyTracerProvider.setDelegate(provider);
		return success;
	};
	/**
	* Returns the global tracer provider.
	*/
	TraceAPI.prototype.getTracerProvider = function() {
		return getGlobal(API_NAME) || this._proxyTracerProvider;
	};
	/**
	* Returns a tracer from the global tracer provider.
	*/
	TraceAPI.prototype.getTracer = function(name, version) {
		return this.getTracerProvider().getTracer(name, version);
	};
	/** Remove the global tracer provider */
	TraceAPI.prototype.disable = function() {
		unregisterGlobal(API_NAME, DiagAPI.instance());
		this._proxyTracerProvider = new ProxyTracerProvider();
	};
	return TraceAPI;
})().getInstance();
var __defProp = Object.defineProperty;
var __export = (target, all) => {
	for (var name17 in all) __defProp(target, name17, {
		get: all[name17],
		enumerable: true
	});
};
function prepareResponseHeaders(headers, { contentType, dataStreamVersion }) {
	const responseHeaders = new Headers(headers != null ? headers : {});
	if (!responseHeaders.has("Content-Type")) responseHeaders.set("Content-Type", contentType);
	if (dataStreamVersion !== void 0) responseHeaders.set("X-Vercel-AI-Data-Stream", dataStreamVersion);
	return responseHeaders;
}
var name4 = "AI_NoObjectGeneratedError";
var marker4 = `vercel.ai.error.${name4}`;
var symbol4 = Symbol.for(marker4);
var _a4;
var NoObjectGeneratedError = class extends AISDKError {
	constructor({ message = "No object generated.", cause, text: text2, response, usage, finishReason }) {
		super({
			name: name4,
			message,
			cause
		});
		this[_a4] = true;
		this.text = text2;
		this.response = response;
		this.usage = usage;
		this.finishReason = finishReason;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker4);
	}
};
_a4 = symbol4;
var dataContentSchema = z$1.union([
	z$1.string(),
	z$1.instanceof(Uint8Array),
	z$1.instanceof(ArrayBuffer),
	z$1.custom((value) => {
		var _a17, _b;
		return (_b = (_a17 = globalThis.Buffer) == null ? void 0 : _a17.isBuffer(value)) != null ? _b : false;
	}, { message: "Must be a Buffer" })
]);
var jsonValueSchema = z$1.lazy(() => z$1.union([
	z$1.null(),
	z$1.string(),
	z$1.number(),
	z$1.boolean(),
	z$1.record(z$1.string(), jsonValueSchema),
	z$1.array(jsonValueSchema)
]));
var providerMetadataSchema = z$1.record(z$1.string(), z$1.record(z$1.string(), jsonValueSchema));
var toolResultContentSchema = z$1.array(z$1.union([z$1.object({
	type: z$1.literal("text"),
	text: z$1.string()
}), z$1.object({
	type: z$1.literal("image"),
	data: z$1.string(),
	mimeType: z$1.string().optional()
})]));
var textPartSchema = z$1.object({
	type: z$1.literal("text"),
	text: z$1.string(),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var imagePartSchema = z$1.object({
	type: z$1.literal("image"),
	image: z$1.union([dataContentSchema, z$1.instanceof(URL)]),
	mimeType: z$1.string().optional(),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var filePartSchema = z$1.object({
	type: z$1.literal("file"),
	data: z$1.union([dataContentSchema, z$1.instanceof(URL)]),
	filename: z$1.string().optional(),
	mimeType: z$1.string(),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var reasoningPartSchema = z$1.object({
	type: z$1.literal("reasoning"),
	text: z$1.string(),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var redactedReasoningPartSchema = z$1.object({
	type: z$1.literal("redacted-reasoning"),
	data: z$1.string(),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var toolCallPartSchema = z$1.object({
	type: z$1.literal("tool-call"),
	toolCallId: z$1.string(),
	toolName: z$1.string(),
	args: z$1.unknown(),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var toolResultPartSchema = z$1.object({
	type: z$1.literal("tool-result"),
	toolCallId: z$1.string(),
	toolName: z$1.string(),
	result: z$1.unknown(),
	content: toolResultContentSchema.optional(),
	isError: z$1.boolean().optional(),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var coreSystemMessageSchema = z$1.object({
	role: z$1.literal("system"),
	content: z$1.string(),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var coreUserMessageSchema = z$1.object({
	role: z$1.literal("user"),
	content: z$1.union([z$1.string(), z$1.array(z$1.union([
		textPartSchema,
		imagePartSchema,
		filePartSchema
	]))]),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var coreAssistantMessageSchema = z$1.object({
	role: z$1.literal("assistant"),
	content: z$1.union([z$1.string(), z$1.array(z$1.union([
		textPartSchema,
		filePartSchema,
		reasoningPartSchema,
		redactedReasoningPartSchema,
		toolCallPartSchema
	]))]),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
var coreToolMessageSchema = z$1.object({
	role: z$1.literal("tool"),
	content: z$1.array(toolResultPartSchema),
	providerOptions: providerMetadataSchema.optional(),
	experimental_providerMetadata: providerMetadataSchema.optional()
});
z$1.union([
	coreSystemMessageSchema,
	coreUserMessageSchema,
	coreAssistantMessageSchema,
	coreToolMessageSchema
]);
var DEFAULT_SCHEMA_PREFIX = "JSON schema:";
var DEFAULT_SCHEMA_SUFFIX = "You MUST answer with a JSON object that matches the JSON schema above.";
var DEFAULT_GENERIC_SUFFIX = "You MUST answer with JSON.";
function injectJsonInstruction({ prompt, schema, schemaPrefix = schema != null ? DEFAULT_SCHEMA_PREFIX : void 0, schemaSuffix = schema != null ? DEFAULT_SCHEMA_SUFFIX : DEFAULT_GENERIC_SUFFIX }) {
	return [
		prompt != null && prompt.length > 0 ? prompt : void 0,
		prompt != null && prompt.length > 0 ? "" : void 0,
		schemaPrefix,
		schema != null ? JSON.stringify(schema) : void 0,
		schemaSuffix
	].filter((line) => line != null).join("\n");
}
createIdGenerator({
	prefix: "aiobj",
	size: 24
});
createIdGenerator({
	prefix: "aiobj",
	size: 24
});
createIdGenerator({
	prefix: "aitxt",
	size: 24
});
createIdGenerator({
	prefix: "msg",
	size: 24
});
__export({}, {
	object: () => object,
	text: () => text
});
var text = () => ({
	type: "text",
	responseFormat: () => ({ type: "text" }),
	injectIntoSystemPrompt({ system }) {
		return system;
	},
	parsePartial({ text: text2 }) {
		return { partial: text2 };
	},
	parseOutput({ text: text2 }) {
		return text2;
	}
});
var object = ({ schema: inputSchema }) => {
	const schema = asSchema(inputSchema);
	return {
		type: "object",
		responseFormat: ({ model }) => ({
			type: "json",
			schema: model.supportsStructuredOutputs ? schema.jsonSchema : void 0
		}),
		injectIntoSystemPrompt({ system, model }) {
			return model.supportsStructuredOutputs ? system : injectJsonInstruction({
				prompt: system,
				schema: schema.jsonSchema
			});
		},
		parsePartial({ text: text2 }) {
			const result = parsePartialJson(text2);
			switch (result.state) {
				case "failed-parse":
				case "undefined-input": return;
				case "repaired-parse":
				case "successful-parse": return { partial: result.value };
				default: {
					const _exhaustiveCheck = result.state;
					throw new Error(`Unsupported parse state: ${_exhaustiveCheck}`);
				}
			}
		},
		parseOutput({ text: text2 }, context) {
			const parseResult = safeParseJSON({ text: text2 });
			if (!parseResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: could not parse the response.",
				cause: parseResult.error,
				text: text2,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			});
			const validationResult = safeValidateTypes({
				value: parseResult.value,
				schema
			});
			if (!validationResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: response did not match schema.",
				cause: validationResult.error,
				text: text2,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			});
			return validationResult.value;
		}
	};
};
function mergeStreams(stream1, stream2) {
	const reader1 = stream1.getReader();
	const reader2 = stream2.getReader();
	let lastRead1 = void 0;
	let lastRead2 = void 0;
	let stream1Done = false;
	let stream2Done = false;
	async function readStream1(controller) {
		try {
			if (lastRead1 == null) lastRead1 = reader1.read();
			const result = await lastRead1;
			lastRead1 = void 0;
			if (!result.done) controller.enqueue(result.value);
			else controller.close();
		} catch (error) {
			controller.error(error);
		}
	}
	async function readStream2(controller) {
		try {
			if (lastRead2 == null) lastRead2 = reader2.read();
			const result = await lastRead2;
			lastRead2 = void 0;
			if (!result.done) controller.enqueue(result.value);
			else controller.close();
		} catch (error) {
			controller.error(error);
		}
	}
	return new ReadableStream({
		async pull(controller) {
			try {
				if (stream1Done) {
					await readStream2(controller);
					return;
				}
				if (stream2Done) {
					await readStream1(controller);
					return;
				}
				if (lastRead1 == null) lastRead1 = reader1.read();
				if (lastRead2 == null) lastRead2 = reader2.read();
				const { result, reader } = await Promise.race([lastRead1.then((result2) => ({
					result: result2,
					reader: reader1
				})), lastRead2.then((result2) => ({
					result: result2,
					reader: reader2
				}))]);
				if (!result.done) controller.enqueue(result.value);
				if (reader === reader1) {
					lastRead1 = void 0;
					if (result.done) {
						await readStream2(controller);
						stream1Done = true;
					}
				} else {
					lastRead2 = void 0;
					if (result.done) {
						stream2Done = true;
						await readStream1(controller);
					}
				}
			} catch (error) {
				controller.error(error);
			}
		},
		cancel() {
			reader1.cancel();
			reader2.cancel();
		}
	});
}
createIdGenerator({
	prefix: "aitxt",
	size: 24
});
createIdGenerator({
	prefix: "msg",
	size: 24
});
var ClientOrServerImplementationSchema = z$1.object({
	name: z$1.string(),
	version: z$1.string()
}).passthrough();
var BaseParamsSchema = z$1.object({ _meta: z$1.optional(z$1.object({}).passthrough()) }).passthrough();
var ResultSchema = BaseParamsSchema;
var RequestSchema = z$1.object({
	method: z$1.string(),
	params: z$1.optional(BaseParamsSchema)
});
var ServerCapabilitiesSchema = z$1.object({
	experimental: z$1.optional(z$1.object({}).passthrough()),
	logging: z$1.optional(z$1.object({}).passthrough()),
	prompts: z$1.optional(z$1.object({ listChanged: z$1.optional(z$1.boolean()) }).passthrough()),
	resources: z$1.optional(z$1.object({
		subscribe: z$1.optional(z$1.boolean()),
		listChanged: z$1.optional(z$1.boolean())
	}).passthrough()),
	tools: z$1.optional(z$1.object({ listChanged: z$1.optional(z$1.boolean()) }).passthrough())
}).passthrough();
ResultSchema.extend({
	protocolVersion: z$1.string(),
	capabilities: ServerCapabilitiesSchema,
	serverInfo: ClientOrServerImplementationSchema,
	instructions: z$1.optional(z$1.string())
});
var PaginatedResultSchema = ResultSchema.extend({ nextCursor: z$1.optional(z$1.string()) });
var ToolSchema = z$1.object({
	name: z$1.string(),
	description: z$1.optional(z$1.string()),
	inputSchema: z$1.object({
		type: z$1.literal("object"),
		properties: z$1.optional(z$1.object({}).passthrough())
	}).passthrough()
}).passthrough();
PaginatedResultSchema.extend({ tools: z$1.array(ToolSchema) });
var TextContentSchema = z$1.object({
	type: z$1.literal("text"),
	text: z$1.string()
}).passthrough();
var ImageContentSchema = z$1.object({
	type: z$1.literal("image"),
	data: z$1.string().base64(),
	mimeType: z$1.string()
}).passthrough();
var ResourceContentsSchema = z$1.object({
	/**
	* The URI of this resource.
	*/
	uri: z$1.string(),
	/**
	* The MIME type of this resource, if known.
	*/
	mimeType: z$1.optional(z$1.string())
}).passthrough();
var TextResourceContentsSchema = ResourceContentsSchema.extend({ text: z$1.string() });
var BlobResourceContentsSchema = ResourceContentsSchema.extend({ blob: z$1.string().base64() });
var EmbeddedResourceSchema = z$1.object({
	type: z$1.literal("resource"),
	resource: z$1.union([TextResourceContentsSchema, BlobResourceContentsSchema])
}).passthrough();
ResultSchema.extend({
	content: z$1.array(z$1.union([
		TextContentSchema,
		ImageContentSchema,
		EmbeddedResourceSchema
	])),
	isError: z$1.boolean().default(false).optional()
}).or(ResultSchema.extend({ toolResult: z$1.unknown() }));
var JSONRPC_VERSION = "2.0";
var JSONRPCRequestSchema = z$1.object({
	jsonrpc: z$1.literal(JSONRPC_VERSION),
	id: z$1.union([z$1.string(), z$1.number().int()])
}).merge(RequestSchema).strict();
var JSONRPCResponseSchema = z$1.object({
	jsonrpc: z$1.literal(JSONRPC_VERSION),
	id: z$1.union([z$1.string(), z$1.number().int()]),
	result: ResultSchema
}).strict();
var JSONRPCErrorSchema = z$1.object({
	jsonrpc: z$1.literal(JSONRPC_VERSION),
	id: z$1.union([z$1.string(), z$1.number().int()]),
	error: z$1.object({
		code: z$1.number().int(),
		message: z$1.string(),
		data: z$1.optional(z$1.unknown())
	})
}).strict();
var JSONRPCNotificationSchema = z$1.object({ jsonrpc: z$1.literal(JSONRPC_VERSION) }).merge(z$1.object({
	method: z$1.string(),
	params: z$1.optional(BaseParamsSchema)
})).strict();
z$1.union([
	JSONRPCRequestSchema,
	JSONRPCNotificationSchema,
	JSONRPCResponseSchema,
	JSONRPCErrorSchema
]);
__export({}, {
	mergeIntoDataStream: () => mergeIntoDataStream,
	toDataStream: () => toDataStream,
	toDataStreamResponse: () => toDataStreamResponse
});
function createCallbacksTransformer(callbacks = {}) {
	const textEncoder = new TextEncoder();
	let aggregatedResponse = "";
	return new TransformStream({
		async start() {
			if (callbacks.onStart) await callbacks.onStart();
		},
		async transform(message, controller) {
			controller.enqueue(textEncoder.encode(message));
			aggregatedResponse += message;
			if (callbacks.onToken) await callbacks.onToken(message);
			if (callbacks.onText && typeof message === "string") await callbacks.onText(message);
		},
		async flush() {
			if (callbacks.onCompletion) await callbacks.onCompletion(aggregatedResponse);
			if (callbacks.onFinal) await callbacks.onFinal(aggregatedResponse);
		}
	});
}
function toDataStreamInternal(stream, callbacks) {
	return stream.pipeThrough(new TransformStream({ transform: async (value, controller) => {
		var _a17;
		if (typeof value === "string") {
			controller.enqueue(value);
			return;
		}
		if ("event" in value) {
			if (value.event === "on_chat_model_stream") forwardAIMessageChunk((_a17 = value.data) == null ? void 0 : _a17.chunk, controller);
			return;
		}
		forwardAIMessageChunk(value, controller);
	} })).pipeThrough(createCallbacksTransformer(callbacks)).pipeThrough(new TextDecoderStream()).pipeThrough(new TransformStream({ transform: async (chunk, controller) => {
		controller.enqueue(formatDataStreamPart("text", chunk));
	} }));
}
function toDataStream(stream, callbacks) {
	return toDataStreamInternal(stream, callbacks).pipeThrough(new TextEncoderStream());
}
function toDataStreamResponse(stream, options) {
	var _a17;
	const dataStream = toDataStreamInternal(stream, options == null ? void 0 : options.callbacks).pipeThrough(new TextEncoderStream());
	const data = options == null ? void 0 : options.data;
	const init = options == null ? void 0 : options.init;
	const responseStream = data ? mergeStreams(data.stream, dataStream) : dataStream;
	return new Response(responseStream, {
		status: (_a17 = init == null ? void 0 : init.status) != null ? _a17 : 200,
		statusText: init == null ? void 0 : init.statusText,
		headers: prepareResponseHeaders(init == null ? void 0 : init.headers, {
			contentType: "text/plain; charset=utf-8",
			dataStreamVersion: "v1"
		})
	});
}
function mergeIntoDataStream(stream, options) {
	options.dataStream.merge(toDataStreamInternal(stream, options.callbacks));
}
function forwardAIMessageChunk(chunk, controller) {
	if (typeof chunk.content === "string") controller.enqueue(chunk.content);
	else {
		const content = chunk.content;
		for (const item of content) if (item.type === "text") controller.enqueue(item.text);
	}
}
__export({}, {
	mergeIntoDataStream: () => mergeIntoDataStream2,
	toDataStream: () => toDataStream2,
	toDataStreamResponse: () => toDataStreamResponse2
});
function toDataStreamInternal2(stream, callbacks) {
	const trimStart = trimStartOfStream();
	return convertAsyncIteratorToReadableStream(stream[Symbol.asyncIterator]()).pipeThrough(new TransformStream({ async transform(message, controller) {
		controller.enqueue(trimStart(message.delta));
	} })).pipeThrough(createCallbacksTransformer(callbacks)).pipeThrough(new TextDecoderStream()).pipeThrough(new TransformStream({ transform: async (chunk, controller) => {
		controller.enqueue(formatDataStreamPart("text", chunk));
	} }));
}
function toDataStream2(stream, callbacks) {
	return toDataStreamInternal2(stream, callbacks).pipeThrough(new TextEncoderStream());
}
function toDataStreamResponse2(stream, options = {}) {
	var _a17;
	const { init, data, callbacks } = options;
	const dataStream = toDataStreamInternal2(stream, callbacks).pipeThrough(new TextEncoderStream());
	const responseStream = data ? mergeStreams(data.stream, dataStream) : dataStream;
	return new Response(responseStream, {
		status: (_a17 = init == null ? void 0 : init.status) != null ? _a17 : 200,
		statusText: init == null ? void 0 : init.statusText,
		headers: prepareResponseHeaders(init == null ? void 0 : init.headers, {
			contentType: "text/plain; charset=utf-8",
			dataStreamVersion: "v1"
		})
	});
}
function mergeIntoDataStream2(stream, options) {
	options.dataStream.merge(toDataStreamInternal2(stream, options.callbacks));
}
function trimStartOfStream() {
	let isStreamStart = true;
	return (text2) => {
		if (isStreamStart) {
			text2 = text2.trimStart();
			if (text2) isStreamStart = false;
		}
		return text2;
	};
}
//#endregion
//#region src/utils.ts
/**
* Converts a Zod schema to an AI SDK Schema with validation support.
*
* This function mirrors the behavior of Vercel's AI SDK zod-schema utility but allows
* customization of the JSON Schema target format.
*
* @param zodSchema - The Zod schema to convert
* @param target - The JSON Schema target format (defaults to 'jsonSchema7')
* @returns An AI SDK Schema object with built-in validation
*
* @example
* ```typescript
* import { z } from 'zod';
* import { convertZodSchemaToAISDKSchema } from '@mastra/schema-compat';
*
* const userSchema = z.object({
*   name: z.string(),
*   age: z.number().min(0)
* });
*
* const aiSchema = convertZodSchemaToAISDKSchema(userSchema);
* ```
*/
function convertZodSchemaToAISDKSchema(zodSchema, target = "jsonSchema7") {
	return jsonSchema(zodToJsonSchema$1(zodSchema, target), { validate: (value) => {
		const result = zodSchema.safeParse(value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	} });
}
/**
* Checks if a value is a Zod type by examining its properties and methods.
*
* @param value - The value to check
* @returns True if the value is a Zod type, false otherwise
* @internal
*/
function isZodType(value) {
	return typeof value === "object" && value !== null && ("_def" in value || "_zod" in value) && "parse" in value && typeof value.parse === "function" && "safeParse" in value && typeof value.safeParse === "function";
}
/**
* Converts an AI SDK Schema or Zod schema to a Zod schema.
*
* If the input is already a Zod schema, it returns it unchanged.
* If the input is an AI SDK Schema, it extracts the JSON schema and converts it to Zod.
*
* @param schema - The schema to convert (AI SDK Schema or Zod schema)
* @returns A Zod schema equivalent of the input
* @throws Error if the conversion fails
*
* @example
* ```typescript
* import { jsonSchema } from 'ai';
* import { convertSchemaToZod } from '@mastra/schema-compat';
*
* const aiSchema = jsonSchema({
*   type: 'object',
*   properties: {
*     name: { type: 'string' }
*   }
* });
*
* const zodSchema = convertSchemaToZod(aiSchema);
* ```
*/
function convertSchemaToZod(schema) {
	if (isZodType(schema)) return schema;
	else {
		const jsonSchemaToConvert = "jsonSchema" in schema ? schema.jsonSchema : schema;
		try {
			if ("toJSONSchema" in z$1) return convertJsonSchemaToZod(jsonSchemaToConvert);
			else return convertJsonSchemaToZod$1(jsonSchemaToConvert);
		} catch (e) {
			const errorMessage = `[Schema Builder] Failed to convert schema parameters to Zod. Original schema: ${JSON.stringify(jsonSchemaToConvert)}`;
			console.error(errorMessage, e);
			throw new Error(errorMessage + (e instanceof Error ? `\n${e.stack}` : "\nUnknown error object"));
		}
	}
}
/**
* Processes a schema using provider compatibility layers and converts it to the specified format.
*
* This function automatically applies the first matching compatibility layer from the provided
* list based on the model configuration. If no compatibility applies, it falls back to
* standard conversion.
*
* @param options - Configuration object for schema processing
* @param options.schema - The schema to process (AI SDK Schema or Zod object schema)
* @param options.compatLayers - Array of compatibility layers to try
* @param options.mode - Output format: 'jsonSchema' for JSONSchema7 or 'aiSdkSchema' for AI SDK Schema
* @returns Processed schema in the requested format
*
* @example
* ```typescript
* import { z } from 'zod';
* import { applyCompatLayer, OpenAISchemaCompatLayer, AnthropicSchemaCompatLayer } from '@mastra/schema-compat';
*
* const schema = z.object({
*   query: z.string().email(),
*   limit: z.number().min(1).max(100)
* });
*
* const compatLayers = [
*   new OpenAISchemaCompatLayer(model),
*   new AnthropicSchemaCompatLayer(model)
* ];
*
* const result = applyCompatLayer({
*   schema,
*   compatLayers,
*   mode: 'aiSdkSchema'
* });
* ```
*/
function applyCompatLayer({ schema, compatLayers, mode }) {
	if (mode === "jsonSchema") {
		const standardSchema = toStandardSchema(schema);
		for (const compat of compatLayers) if (compat.shouldApply()) return standardSchemaToJSONSchema(compat.processToCompatSchema(standardSchema));
		return standardSchemaToJSONSchema(standardSchema);
	} else {
		let zodSchema;
		if (isZodType(schema)) zodSchema = schema;
		else {
			if (isStandardSchemaWithJSON(schema)) throw new Error("StandardSchemaWithJSON is not supported for applyCompatLayer and aiSdkSchema mode");
			zodSchema = convertSchemaToZod(schema);
		}
		for (const compat of compatLayers) if (compat.shouldApply()) return compat.processToAISDKSchema(zodSchema);
		return convertZodSchemaToAISDKSchema(zodSchema);
	}
}
//#endregion
//#region src/schema-compatibility-v3.ts
/**
* All supported string validation check types that can be processed or converted to descriptions.
* @constant
*/
const ALL_STRING_CHECKS = [
	"regex",
	"emoji",
	"email",
	"url",
	"uuid",
	"cuid",
	"min",
	"max"
];
/**
* All supported number validation check types that can be processed or converted to descriptions.
* @constant
*/
const ALL_NUMBER_CHECKS = [
	"min",
	"max",
	"multipleOf"
];
/**
* All supported array validation check types that can be processed or converted to descriptions.
* @constant
*/
const ALL_ARRAY_CHECKS = [
	"min",
	"max",
	"length"
];
const isOptional = (v) => v instanceof ZodOptional;
const isObj = (v) => v instanceof ZodObject;
const isArr = (v) => v instanceof ZodArray;
const isUnion = (v) => v instanceof ZodUnion;
const isString = (v) => v instanceof ZodString;
const isNumber = (v) => v instanceof ZodNumber;
/**
* Zod types that are not supported by most AI model providers and should be avoided.
* @constant
*/
const UNSUPPORTED_ZOD_TYPES = [
	"ZodIntersection",
	"ZodNever",
	"ZodNull",
	"ZodTuple",
	"ZodUndefined"
];
/**
* Zod types that are generally supported by AI model providers.
* @constant
*/
const SUPPORTED_ZOD_TYPES = [
	"ZodObject",
	"ZodArray",
	"ZodUnion",
	"ZodString",
	"ZodNumber",
	"ZodDate",
	"ZodAny",
	"ZodDefault",
	"ZodNullable"
];
/**
* All Zod types (both supported and unsupported).
* @constant
*/
const ALL_ZOD_TYPES = [...SUPPORTED_ZOD_TYPES, ...UNSUPPORTED_ZOD_TYPES];
/**
* Abstract base class for creating schema compatibility layers for different AI model providers.
*
* This class provides a framework for transforming Zod schemas to work with specific AI model
* provider requirements and limitations. Each provider may have different support levels for
* JSON Schema features, validation constraints, and data types.
*
*
* @example
* ```typescript
* import { SchemaCompatLayer } from '@mastra/schema-compat';
* import type { LanguageModelV1 } from 'ai';
*
* class CustomProviderCompat extends SchemaCompatLayer {
*   constructor(model: ModelInformation) {
*     super(model);
*   }
*
*   shouldApply(): boolean {
*     return this.getModel().provider === 'custom-provider';
*   }
*
*   getSchemaTarget() {
*     return 'jsonSchema7';
*   }
*
*   processZodType<T extends z.AnyZodObject>(value: z.ZodTypeAny): ShapeValue<T> {
*     // Custom processing logic for this provider
*     switch (value._def.typeName) {
*       case 'ZodString':
*         return this.defaultZodStringHandler(value, ['email', 'url']);
*       default:
*         return this.defaultUnsupportedZodTypeHandler(value);
*     }
*   }
* }
* ```
*/
var SchemaCompatLayer$1 = class {
	model;
	parent;
	/**
	* Creates a new schema compatibility instance.
	*
	* @param model - The language model this compatibility layer applies to
	*/
	constructor(model, parent) {
		this.model = model;
		this.parent = parent;
	}
	/**
	* Gets the language model associated with this compatibility layer.
	*
	* @returns The language model instance
	*/
	getModel() {
		return this.model;
	}
	getUnsupportedZodTypes() {
		return UNSUPPORTED_ZOD_TYPES;
	}
	/**
	* Type guard for optional Zod types
	*/
	isOptional(v) {
		return v instanceof ZodOptional;
	}
	/**
	* Type guard for object Zod types
	*/
	isObj(v) {
		return v instanceof ZodObject;
	}
	/**
	* Type guard for null Zod types
	*/
	isNull(v) {
		return v instanceof ZodNull;
	}
	/**
	* Type guard for nullable Zod types
	*/
	isNullable(v) {
		return v instanceof ZodNullable;
	}
	/**
	* Type guard for array Zod types
	*/
	isArr(v) {
		return v instanceof ZodArray;
	}
	/**
	* Type guard for union Zod types
	*/
	isUnion(v) {
		return v instanceof ZodUnion;
	}
	/**
	* Type guard for string Zod types
	*/
	isString(v) {
		return v instanceof ZodString;
	}
	/**
	* Type guard for number Zod types
	*/
	isNumber(v) {
		return v instanceof ZodNumber;
	}
	/**
	* Type guard for date Zod types
	*/
	isDate(v) {
		return v instanceof ZodDate;
	}
	/**
	* Type guard for default Zod types
	*/
	isDefault(v) {
		return v instanceof ZodDefault;
	}
	/**
	* Type guard for intersection Zod types
	*/
	isIntersection(v) {
		return v instanceof ZodIntersection;
	}
	/**
	* Determines whether this compatibility layer should be applied for the current model.
	*
	* @returns True if this compatibility layer should be used, false otherwise
	* @abstract
	*/
	shouldApply() {
		return this.parent.shouldApply();
	}
	/**
	* Returns the JSON Schema target format for this provider.
	*
	* @returns The schema target format, or undefined to use the default 'jsonSchema7'
	* @abstract
	*/
	getSchemaTarget() {
		return this.parent.getSchemaTarget();
	}
	/**
	* Processes a specific Zod type according to the provider's requirements.
	*
	* @param value - The Zod type to process
	* @returns The processed Zod type
	* @abstract
	*/
	processZodType(value) {
		return this.parent.processZodType(value);
	}
	/**
	* Default handler for Zod object types. Recursively processes all properties in the object.
	*
	* @param value - The Zod object to process
	* @returns The processed Zod object
	*/
	defaultZodObjectHandler(value, options = { passthrough: true }) {
		const processedShape = Object.entries(value.shape).reduce((acc, [key, propValue]) => {
			acc[key] = this.processZodType(propValue);
			return acc;
		}, {});
		let result = z.object(processedShape);
		if (value._def.unknownKeys === "strict") result = result.strict();
		if (value._def.catchall && !(value._def.catchall instanceof z.ZodNever)) result = result.catchall(value._def.catchall);
		if (value.description) result = result.describe(value.description);
		if (options.passthrough && value._def.unknownKeys === "passthrough") result = result.passthrough();
		return result;
	}
	/**
	* Merges validation constraints into a parameter description.
	*
	* This helper method converts validation constraints that may not be supported
	* by a provider into human-readable descriptions.
	*
	* @param description - The existing parameter description
	* @param constraints - The validation constraints to merge
	* @returns The updated description with constraints, or undefined if no constraints
	*/
	mergeParameterDescription(description, constraints) {
		if (constraints.length > 0) return (description ? description + "\n" : "") + `constraints: ${constraints.join(`, `)}`;
		else return description;
	}
	/**
	* Default handler for unsupported Zod types. Throws an error for specified unsupported types.
	*
	* @param value - The Zod type to check
	* @param throwOnTypes - Array of type names to throw errors for
	* @returns The original value if not in the throw list
	* @throws Error if the type is in the unsupported list
	*/
	defaultUnsupportedZodTypeHandler(value, throwOnTypes = UNSUPPORTED_ZOD_TYPES) {
		if (throwOnTypes.includes(value._def?.typeName)) throw new Error(`${this.model.modelId} does not support zod type: ${value._def?.typeName}`);
		return value;
	}
	/**
	* Default handler for Zod array types. Processes array constraints according to provider support.
	*
	* @param value - The Zod array to process
	* @param handleChecks - Array constraints to convert to descriptions vs keep as validation
	* @returns The processed Zod array
	*/
	defaultZodArrayHandler(value, handleChecks = ALL_ARRAY_CHECKS) {
		const zodArrayDef = value._def;
		const processedType = this.processZodType(zodArrayDef.type);
		let result = z.array(processedType);
		const constraints = [];
		if (zodArrayDef.minLength?.value !== void 0) if (handleChecks.includes("min")) constraints.push(`minimum length ${zodArrayDef.minLength.value}`);
		else result = result.min(zodArrayDef.minLength.value);
		if (zodArrayDef.maxLength?.value !== void 0) if (handleChecks.includes("max")) constraints.push(`maximum length ${zodArrayDef.maxLength.value}`);
		else result = result.max(zodArrayDef.maxLength.value);
		if (zodArrayDef.exactLength?.value !== void 0) if (handleChecks.includes("length")) constraints.push(`exact length ${zodArrayDef.exactLength.value}`);
		else result = result.length(zodArrayDef.exactLength.value);
		const description = this.mergeParameterDescription(value.description, constraints);
		if (description) result = result.describe(description);
		return result;
	}
	/**
	* Default handler for Zod union types. Processes all union options.
	*
	* @param value - The Zod union to process
	* @returns The processed Zod union
	* @throws Error if union has fewer than 2 options
	*/
	defaultZodUnionHandler(value) {
		const processedOptions = value._def.options.map((option) => this.processZodType(option));
		if (processedOptions.length < 2) throw new Error("Union must have at least 2 options");
		let result = z.union(processedOptions);
		if (value.description) result = result.describe(value.description);
		return result;
	}
	/**
	* Default handler for Zod string types. Processes string validation constraints.
	*
	* @param value - The Zod string to process
	* @param handleChecks - String constraints to convert to descriptions vs keep as validation
	* @returns The processed Zod string
	*/
	defaultZodStringHandler(value, handleChecks = ALL_STRING_CHECKS) {
		const constraints = [];
		const checks = value._def.checks || [];
		const newChecks = [];
		for (const check of checks) if ("kind" in check) if (handleChecks.includes(check.kind)) switch (check.kind) {
			case "regex":
				constraints.push(`input must match this regex ${check.regex.source}`);
				break;
			case "emoji":
			case "email":
			case "url":
			case "uuid":
			case "cuid":
				constraints.push(`a valid ${check.kind}`);
				break;
			case "min":
			case "max":
				constraints.push(`${check.kind}imum length ${check.value}`);
				break;
		}
		else newChecks.push(check);
		let result = z.string();
		for (const check of newChecks) result = result._addCheck(check);
		const description = this.mergeParameterDescription(value.description, constraints);
		if (description) result = result.describe(description);
		return result;
	}
	/**
	* Default handler for Zod number types. Processes number validation constraints.
	*
	* @param value - The Zod number to process
	* @param handleChecks - Number constraints to convert to descriptions vs keep as validation
	* @returns The processed Zod number
	*/
	defaultZodNumberHandler(value, handleChecks = ALL_NUMBER_CHECKS) {
		const constraints = [];
		const checks = value._def.checks || [];
		const newChecks = [];
		for (const check of checks) if ("kind" in check) if (handleChecks.includes(check.kind)) switch (check.kind) {
			case "min":
				if (check.inclusive) constraints.push(`greater than or equal to ${check.value}`);
				else constraints.push(`greater than ${check.value}`);
				break;
			case "max":
				if (check.inclusive) constraints.push(`lower than or equal to ${check.value}`);
				else constraints.push(`lower than ${check.value}`);
				break;
			case "multipleOf":
				constraints.push(`multiple of ${check.value}`);
				break;
		}
		else newChecks.push(check);
		let result = z.number();
		for (const check of newChecks) switch (check.kind) {
			case "int":
				result = result.int();
				break;
			case "finite":
				result = result.finite();
				break;
			default: result = result._addCheck(check);
		}
		const description = this.mergeParameterDescription(value.description, constraints);
		if (description) result = result.describe(description);
		return result;
	}
	/**
	* Default handler for Zod date types. Converts dates to ISO strings with constraint descriptions.
	*
	* @param value - The Zod date to process
	* @returns A Zod string schema representing the date in ISO format
	*/
	defaultZodDateHandler(value) {
		const constraints = [];
		const checks = value._def.checks || [];
		const newChecks = [];
		for (const check of checks) if ("kind" in check) switch (check.kind) {
			case "min":
				const minDate = new Date(check.value);
				if (!isNaN(minDate.getTime())) constraints.push(`Date must be newer than ${minDate.toISOString()} (ISO)`);
				break;
			case "max":
				const maxDate = new Date(check.value);
				if (!isNaN(maxDate.getTime())) constraints.push(`Date must be older than ${maxDate.toISOString()} (ISO)`);
				break;
			default: newChecks.push(check);
		}
		constraints.push(`Date format is date-time`);
		let result = z.string().describe("date-time");
		const description = this.mergeParameterDescription(value.description, constraints);
		if (description) result = result.describe(description);
		return result;
	}
	/**
	* Default handler for Zod optional types. Processes the inner type and maintains optionality.
	*
	* @param value - The Zod optional to process
	* @param handleTypes - Types that should be processed vs passed through
	* @returns The processed Zod optional
	*/
	defaultZodOptionalHandler(value, handleTypes = SUPPORTED_ZOD_TYPES) {
		if (handleTypes.includes(value._def.innerType._def.typeName)) return this.processZodType(value._def.innerType).optional();
		else return value;
	}
	/**
	* Default handler for Zod nullable types. Processes the inner type and maintains nullability.
	*
	* @param value - The Zod nullable to process
	* @param handleTypes - Types that should be processed vs passed through
	* @returns The processed Zod nullable
	*/
	defaultZodNullableHandler(value, handleTypes = SUPPORTED_ZOD_TYPES) {
		if (handleTypes.includes(value._def.innerType._def.typeName)) return this.processZodType(value._def.innerType).nullable();
		else return value;
	}
	/**
	* Recursively collects leaf types from a ZodIntersection tree.
	*/
	collectIntersectionLeaves(value) {
		if (value instanceof ZodIntersection) return [...this.collectIntersectionLeaves(value._def.left), ...this.collectIntersectionLeaves(value._def.right)];
		return [value];
	}
	/**
	* Default handler for Zod intersection types.
	* Flattens the intersection tree and merges object shapes into a single z.object().
	* Falls back to z.any() for non-object intersections.
	*/
	defaultZodIntersectionHandler(value) {
		const processed = this.collectIntersectionLeaves(value).map((leaf) => this.processZodType(leaf));
		if (processed.every((p) => p instanceof ZodObject)) {
			const mergedShape = {};
			for (const obj of processed) Object.assign(mergedShape, obj.shape);
			let result = z.object(mergedShape);
			if (value.description) result = result.describe(value.description);
			return result;
		}
		return z.any().describe(value.description || "intersection type");
	}
	/**
	* Processes a Zod object schema and converts it to an AI SDK Schema.
	*
	* @param zodSchema - The Zod object schema to process
	* @returns An AI SDK Schema with provider-specific compatibility applied
	*/
	processToAISDKSchema(zodSchema) {
		return convertZodSchemaToAISDKSchema(this.processZodType(zodSchema), this.getSchemaTarget());
	}
	/**
	* Processes a Zod object schema and converts it to a JSON Schema.
	*
	* @param zodSchema - The Zod object schema to process
	* @returns A JSONSchema7 object with provider-specific compatibility applied
	*/
	processToJSONSchema(zodSchema) {
		return this.processToAISDKSchema(zodSchema).jsonSchema;
	}
};
//#endregion
//#region src/schema-compatibility-v4.ts
/**
* All supported string validation check types that can be processed or converted to descriptions.
* @constant
*/
const ALL_STRING_CHECKS$1 = [
	"regex",
	"emoji",
	"email",
	"url",
	"uuid",
	"cuid",
	"min_length",
	"max_length",
	"string_format"
];
/**
* All supported number validation check types that can be processed or converted to descriptions.
* @constant
*/
const ALL_NUMBER_CHECKS$1 = [
	"greater_than",
	"less_than",
	"multiple_of"
];
/**
* All supported array validation check types that can be processed or converted to descriptions.
* @constant
*/
const ALL_ARRAY_CHECKS$1 = [
	"min",
	"max",
	"length"
];
/**
* Zod types that are not supported by most AI model providers and should be avoided.
* @constant
*/
const UNSUPPORTED_ZOD_TYPES$2 = [
	"ZodIntersection",
	"ZodNever",
	"ZodNull",
	"ZodTuple",
	"ZodUndefined"
];
/**
* Zod types that are generally supported by AI model providers.
* @constant
*/
const SUPPORTED_ZOD_TYPES$2 = [
	"ZodObject",
	"ZodArray",
	"ZodUnion",
	"ZodString",
	"ZodNumber",
	"ZodDate",
	"ZodAny",
	"ZodDefault",
	"ZodNullable"
];
[...SUPPORTED_ZOD_TYPES$2, ...UNSUPPORTED_ZOD_TYPES$2];
/**
* Returns the v3-style type name (e.g. "ZodString") for a Zod v4 schema. Zod v4
* stores the kind as a lowercase `type` (e.g. "string"), so this normalizes it
* for comparison against the `*_ZOD_TYPES` lists, mirroring the dispatcher in
* `schema-compatibility.ts`.
*/
function zodV4TypeName(value) {
	const v4Type = value?._zod?.def?.type;
	return v4Type ? "Zod" + v4Type.charAt(0).toUpperCase() + v4Type.slice(1) : "";
}
/**
* Abstract base class for creating schema compatibility layers for different AI model providers.
*
* This class provides a framework for transforming Zod schemas to work with specific AI model
* provider requirements and limitations. Each provider may have different support levels for
* JSON Schema features, validation constraints, and data types.
*
*
* @example
* ```typescript
* import { SchemaCompatLayer } from '@mastra/schema-compat';
* import type { LanguageModelV1 } from 'ai';
*
* class CustomProviderCompat extends SchemaCompatLayer {
*   constructor(model: LanguageModelV1) {
*     super(model);
*   }
*
*   shouldApply(): boolean {
*     return this.getModel().provider === 'custom-provider';
*   }
*
*   getSchemaTarget() {
*     return 'jsonSchema7';
*   }
*
*   processZodType<T extends z.AnyZodObject>(value: z.ZodAny): ShapeValue<T> {
*     // Custom processing logic for this provider
*     switch (value._def.typeName) {
*       case 'ZodString':
*         return this.defaultZodStringHandler(value, ['email', 'url']);
*       default:
*         return this.defaultUnsupportedZodTypeHandler(value);
*     }
*   }
* }
* ```
*/
var SchemaCompatLayer$2 = class {
	model;
	parent;
	/**
	* Creates a new schema compatibility instance.
	*
	* @param model - The language model this compatibility layer applies to
	*/
	constructor(model, parent) {
		this.model = model;
		this.parent = parent;
	}
	/**
	* Gets the language model associated with this compatibility layer.
	*
	* @returns The language model instance
	*/
	getModel() {
		return this.model;
	}
	getUnsupportedZodTypes() {
		return UNSUPPORTED_ZOD_TYPES$2;
	}
	/**
	* Type guard for optional Zod types
	*/
	isOptional(v) {
		return v instanceof ZodOptional$1;
	}
	/**
	* Type guard for object Zod types
	*/
	isObj(v) {
		return v instanceof ZodObject$1;
	}
	/**
	* Type guard for null Zod types
	*/
	isNull(v) {
		return v instanceof ZodNull$1;
	}
	/**
	* Type guard for nullable Zod types
	*/
	isNullable(v) {
		return v instanceof ZodNullable$1;
	}
	/**
	* Type guard for array Zod types
	*/
	isArr(v) {
		return v instanceof ZodArray$1;
	}
	/**
	* Type guard for union Zod types
	*/
	isUnion(v) {
		return v instanceof ZodUnion$1;
	}
	/**
	* Type guard for string Zod types
	*/
	isString(v) {
		return v instanceof ZodString$1;
	}
	/**
	* Type guard for number Zod types
	*/
	isNumber(v) {
		return v instanceof ZodNumber$1;
	}
	/**
	* Type guard for date Zod types
	*/
	isDate(v) {
		return v instanceof ZodDate$1;
	}
	/**
	* Type guard for default Zod types
	*/
	isDefault(v) {
		return v instanceof ZodDefault$1;
	}
	/**
	* Type guard for intersection Zod types
	*/
	isIntersection(v) {
		return v instanceof ZodIntersection$1;
	}
	/**
	* Determines whether this compatibility layer should be applied for the current model.
	*
	* @returns True if this compatibility layer should be used, false otherwise
	* @abstract
	*/
	shouldApply() {
		return this.parent.shouldApply();
	}
	/**
	* Returns the JSON Schema target format for this provider.
	*
	* @returns The schema target format, or undefined to use the default 'jsonSchema7'
	* @abstract
	*/
	getSchemaTarget() {
		return this.parent.getSchemaTarget();
	}
	/**
	* Processes a specific Zod type according to the provider's requirements.
	*
	* @param value - The Zod type to process
	* @returns The processed Zod type
	* @abstract
	*/
	processZodType(value) {
		return this.parent.processZodType(value);
	}
	/**
	* Default handler for Zod object types. Recursively processes all properties in the object.
	*
	* @param value - The Zod object to process
	* @returns The processed Zod object
	*/
	defaultZodObjectHandler(value, options = { passthrough: true }) {
		const processedShape = Object.entries(value.shape).reduce((acc, [key, propValue]) => {
			acc[key] = this.processZodType(propValue);
			return acc;
		}, {});
		let result = z$2.object(processedShape);
		if (value._zod.def.catchall instanceof z$2.ZodNever) result = z$2.strictObject(processedShape);
		else if (value._zod.def.catchall instanceof z$2.ZodUnknown) {
			if (options.passthrough) result = z$2.looseObject(processedShape);
		} else if (value._zod.def.catchall) result = result.catchall(value._zod.def.catchall);
		if (value.description) result = result.describe(value.description);
		return result;
	}
	/**
	* Merges validation constraints into a parameter description.
	*
	* This helper method converts validation constraints that may not be supported
	* by a provider into human-readable descriptions.
	*
	* @param description - The existing parameter description
	* @param constraints - The validation constraints to merge
	* @returns The updated description with constraints, or undefined if no constraints
	*/
	mergeParameterDescription(description, constraints) {
		if (constraints.length > 0) return (description ? description + "\n" : "") + `constraints: ${constraints.join(`, `)}`;
		else return description;
	}
	/**
	* Default handler for unsupported Zod types. Throws an error for specified unsupported types.
	*
	* @param value - The Zod type to check
	* @param throwOnTypes - Array of type names to throw errors for
	* @returns The original value if not in the throw list
	* @throws Error if the type is in the unsupported list
	*/
	defaultUnsupportedZodTypeHandler(value, throwOnTypes = UNSUPPORTED_ZOD_TYPES$2) {
		if (throwOnTypes.includes(value.constructor.name)) throw new Error(`${this.model.modelId} does not support zod type: ${value.constructor.name}`);
		return value;
	}
	/**
	* Default handler for Zod array types. Processes array constraints according to provider support.
	*
	* @param value - The Zod array to process
	* @param handleChecks - Array constraints to convert to descriptions vs keep as validation
	* @returns The processed Zod array
	*/
	defaultZodArrayHandler(value, handleChecks = ALL_ARRAY_CHECKS$1) {
		const zodArrayDef = value._zod.def;
		const processedType = this.processZodType(zodArrayDef.element);
		let result = z$2.array(processedType);
		const constraints = [];
		if (zodArrayDef.checks) for (const check of zodArrayDef.checks) {
			if (check._zod.def.check === "min_length") if (handleChecks.includes("min")) constraints.push(`minimum length ${check._zod.def.minimum}`);
			else result = result.min(check._zod.def.minimum);
			if (check._zod.def.check === "max_length") if (handleChecks.includes("max")) constraints.push(`maximum length ${check._zod.def.maximum}`);
			else result = result.max(check._zod.def.maximum);
			if (check._zod.def.check === "length_equals") if (handleChecks.includes("length")) constraints.push(`exact length ${check._zod.def.length}`);
			else result = result.length(check._zod.def.length);
		}
		const metaDescription = value.meta()?.description;
		const legacyDescription = value.description;
		const description = this.mergeParameterDescription(metaDescription || legacyDescription, constraints);
		if (description) result = result.describe(description);
		return result;
	}
	/**
	* Default handler for Zod union types. Processes all union options.
	*
	* @param value - The Zod union to process
	* @returns The processed Zod union
	* @throws Error if union has fewer than 2 options
	*/
	defaultZodUnionHandler(value) {
		const processedOptions = value._zod.def.options.map((option) => this.processZodType(option));
		if (processedOptions.length < 2) throw new Error("Union must have at least 2 options");
		let result = z$2.union(processedOptions);
		if (value.description) result = result.describe(value.description);
		return result;
	}
	/**
	* Default handler for Zod string types. Processes string validation constraints.
	*
	* @param value - The Zod string to process
	* @param handleChecks - String constraints to convert to descriptions vs keep as validation
	* @returns The processed Zod string
	*/
	defaultZodStringHandler(value, handleChecks = ALL_STRING_CHECKS$1) {
		const constraints = [];
		const checks = value._zod.def.checks || [];
		const newChecks = [];
		if (checks) for (const check of checks) if (handleChecks.includes(check._zod.def.check)) switch (check._zod.def.check) {
			case "min_length":
				constraints.push(`minimum length ${check._zod.def.minimum}`);
				break;
			case "max_length":
				constraints.push(`maximum length ${check._zod.def.maximum}`);
				break;
			case "string_format":
				switch (check._zod.def.format) {
					case "email":
					case "url":
					case "emoji":
					case "uuid":
					case "cuid":
						constraints.push(`a valid ${check._zod.def.format}`);
						break;
					case "regex":
						constraints.push(`input must match this regex ${check._zod.def.pattern}`);
						break;
					default:
						newChecks.push(check);
						break;
				}
				break;
		}
		else newChecks.push(check);
		let result = z$2.string();
		for (const check of newChecks) result = result.check(check);
		const metaDescription = value.meta()?.description;
		const legacyDescription = value.description;
		const description = this.mergeParameterDescription(metaDescription || legacyDescription, constraints);
		if (description) result = result.describe(description);
		return result;
	}
	/**
	* Default handler for Zod number types. Processes number validation constraints.
	*
	* @param value - The Zod number to process
	* @param handleChecks - Number constraints to convert to descriptions vs keep as validation
	* @returns The processed Zod number
	*/
	defaultZodNumberHandler(value, handleChecks = ALL_NUMBER_CHECKS$1) {
		const constraints = [];
		const checks = value._zod.def.checks || [];
		const newChecks = [];
		if (checks) for (const check of checks) if (handleChecks.includes(check._zod.def.check)) switch (check._zod.def.check) {
			case "greater_than":
				if (check._zod.def.inclusive) constraints.push(`greater than or equal to ${check._zod.def.value}`);
				else constraints.push(`greater than ${check._zod.def.value}`);
				break;
			case "less_than":
				if (check._zod.def.inclusive) constraints.push(`lower than or equal to ${check._zod.def.value}`);
				else constraints.push(`lower than ${check._zod.def.value}`);
				break;
			case "multiple_of":
				constraints.push(`multiple of ${check._zod.def.value}`);
				break;
		}
		else newChecks.push(check);
		let result = z$2.number();
		for (const check of newChecks) switch (check._zod.def.check) {
			case "number_format":
				switch (check._zod.def.format) {
					case "safeint":
						result = result.int();
						break;
				}
				break;
			default: result = result.check(check);
		}
		const description = this.mergeParameterDescription(value.description, constraints);
		if (description) result = result.describe(description);
		return result;
	}
	/**
	* Default handler for Zod date types. Converts dates to ISO strings with constraint descriptions.
	*
	* @param value - The Zod date to process
	* @returns A Zod string schema representing the date in ISO format
	*/
	defaultZodDateHandler(value) {
		const constraints = [];
		const checks = value._zod.def.checks || [];
		const newChecks = [];
		if (checks) for (const check of checks) switch (check._zod.def.check) {
			case "less_than":
				const maxDate = new Date(check._zod.def.value);
				if (!isNaN(maxDate.getTime())) constraints.push(`Date must be older than ${maxDate.toISOString()} (ISO)`);
				break;
			case "greater_than":
				const minDate = new Date(check._zod.def.value);
				if (!isNaN(minDate.getTime())) constraints.push(`Date must be newer than ${minDate.toISOString()} (ISO)`);
				break;
			default: newChecks.push(check);
		}
		constraints.push(`Date format is date-time`);
		let result = z$2.string().describe("date-time");
		const description = this.mergeParameterDescription(value.description, constraints);
		if (description) result = result.describe(description);
		return result;
	}
	/**
	* Default handler for Zod optional types. Processes the inner type and maintains optionality.
	*
	* @param value - The Zod optional to process
	* @param handleTypes - Types that should be processed vs passed through
	* @returns The processed Zod optional
	*/
	defaultZodOptionalHandler(value, handleTypes = SUPPORTED_ZOD_TYPES$2) {
		const innerType = value._zod?.def?.innerType;
		if (innerType && handleTypes.includes(zodV4TypeName(innerType))) return this.processZodType(innerType).optional();
		else return value;
	}
	/**
	* Default handler for Zod nullable types. Processes the inner type and maintains nullability.
	*
	* @param value - The Zod nullable to process
	* @param handleTypes - Types that should be processed vs passed through
	* @returns The processed Zod nullable
	*/
	defaultZodNullableHandler(value, handleTypes = SUPPORTED_ZOD_TYPES$2) {
		const innerType = value._zod?.def?.innerType;
		if (innerType && handleTypes.includes(zodV4TypeName(innerType))) return this.processZodType(innerType).nullable();
		else return value;
	}
	/**
	* Recursively collects leaf types from a ZodIntersection tree.
	*/
	collectIntersectionLeaves(value) {
		if (value instanceof ZodIntersection$1) return [...this.collectIntersectionLeaves(value._zod.def.left), ...this.collectIntersectionLeaves(value._zod.def.right)];
		return [value];
	}
	/**
	* Default handler for Zod intersection types.
	* Flattens the intersection tree and merges object shapes into a single z.object().
	* Falls back to z.any() for non-object intersections.
	*/
	defaultZodIntersectionHandler(value) {
		const processed = this.collectIntersectionLeaves(value).map((leaf) => this.processZodType(leaf));
		if (processed.every((p) => p instanceof ZodObject$1)) {
			const mergedShape = {};
			for (const obj of processed) for (const [key, field] of Object.entries(obj.shape)) {
				if (key in mergedShape) throw new Error("Cannot flatten intersections with overlapping keys");
				mergedShape[key] = field;
			}
			let result = z$2.object(mergedShape);
			if (value.description) result = result.describe(value.description);
			return result;
		}
		return z$2.any().describe(value.description || "intersection type");
	}
	/**
	* Processes a Zod object schema and converts it to an AI SDK Schema.
	*
	* @param zodSchema - The Zod object schema to process
	* @returns An AI SDK Schema with provider-specific compatibility applied
	*/
	processToAISDKSchema(zodSchema) {
		return convertZodSchemaToAISDKSchema(this.processZodType(zodSchema), this.getSchemaTarget());
	}
	/**
	* Processes a Zod object schema and converts it to a JSON Schema.
	*
	* @param zodSchema - The Zod object schema to process
	* @returns A JSONSchema7 object with provider-specific compatibility applied
	*/
	processToJSONSchema(zodSchema) {
		return this.processToAISDKSchema(zodSchema).jsonSchema;
	}
};
//#endregion
//#region src/json-schema/utils.ts
var import_json_schema_traverse = /* @__PURE__ */ __toESM$1(require_json_schema_traverse(), 1);
/**
* Type guard to check if a JSON Schema has a specific type
*/
function hasType(schema, type) {
	if (schema.type === type) return true;
	if (Array.isArray(schema.type) && schema.type.includes(type)) return true;
	return false;
}
/**
* Check if a JSON Schema represents an object type
*/
function isObjectSchema(schema) {
	return hasType(schema, "object") || schema.properties !== void 0;
}
/**
* Check if a JSON Schema represents an array type
*/
function isArraySchema(schema) {
	return hasType(schema, "array") || schema.items !== void 0;
}
/**
* Check if a JSON Schema represents a string type
*/
function isStringSchema(schema) {
	return hasType(schema, "string");
}
/**
* Check if a JSON Schema represents a number type (number or integer)
*/
function isNumberSchema(schema) {
	return hasType(schema, "number") || hasType(schema, "integer");
}
/**
* Check if a JSON Schema uses anyOf
*/
function isAnyOfSchema(schema) {
	return Array.isArray(schema.anyOf) && schema.anyOf.length > 0;
}
/**
* Check if a JSON Schema uses oneOf
*/
function isOneOfSchema(schema) {
	return Array.isArray(schema.oneOf) && schema.oneOf.length > 0;
}
/**
* Check if a JSON Schema is a union type (anyOf or oneOf)
*/
function isUnionSchema(schema) {
	return isAnyOfSchema(schema) || isOneOfSchema(schema) || Array.isArray(schema.type);
}
/**
* Check if a JSON Schema uses allOf (intersection)
*/
function isAllOfSchema(schema) {
	return Array.isArray(schema.allOf) && schema.allOf.length > 0;
}
/**
* Check if a property is optional within a parent object schema.
* A property is optional if it's not in the parent's `required` array.
* @param propertyName - The name of the property to check
* @param parentSchema - The parent object schema containing the property
*/
function isOptionalSchema(propertyName, parentSchema) {
	if (!parentSchema.required || !Array.isArray(parentSchema.required)) return true;
	return !parentSchema.required.includes(propertyName);
}
//#endregion
//#region src/schema-compatibility.ts
var SchemaCompatLayer = class {
	model;
	v3Layer;
	v4Layer;
	/**
	* Creates a new schema compatibility instance.
	*
	* @param model - The language model this compatibility layer applies to
	*/
	constructor(model) {
		this.model = model;
		this.v3Layer = new SchemaCompatLayer$1(model, this);
		this.v4Layer = new SchemaCompatLayer$2(model, this);
	}
	preProcessJSONNode(_schema, _parentSchema) {}
	postProcessJSONNode(_schema, _parentSchema) {}
	/**
	* Gets the language model associated with this compatibility layer.
	*
	* @returns The language model instance
	*/
	getModel() {
		return this.model;
	}
	getUnsupportedZodTypes(value) {
		if ("_zod" in value) return this.v4Layer.getUnsupportedZodTypes();
		else return this.v3Layer.getUnsupportedZodTypes();
	}
	isOptional(v) {
		if ("_zod" in v) return this.v4Layer.isOptional(v);
		else return this.v3Layer.isOptional(v);
	}
	isObj(v) {
		if ("_zod" in v) return this.v4Layer.isObj(v);
		else return this.v3Layer.isObj(v);
	}
	isNull(v) {
		if ("_zod" in v) return this.v4Layer.isNull(v);
		else return this.v3Layer.isNull(v);
	}
	isNullable(v) {
		if ("_zod" in v) return this.v4Layer.isNullable(v);
		else return this.v3Layer.isNullable(v);
	}
	isArr(v) {
		if ("_zod" in v) return this.v4Layer.isArr(v);
		else return this.v3Layer.isArr(v);
	}
	isUnion(v) {
		if ("_zod" in v) return this.v4Layer.isUnion(v);
		else return this.v3Layer.isUnion(v);
	}
	isString(v) {
		if ("_zod" in v) return this.v4Layer.isString(v);
		else return this.v3Layer.isString(v);
	}
	isNumber(v) {
		if ("_zod" in v) return this.v4Layer.isNumber(v);
		else return this.v3Layer.isNumber(v);
	}
	isDate(v) {
		if ("_zod" in v) return this.v4Layer.isDate(v);
		else return this.v3Layer.isDate(v);
	}
	isDefault(v) {
		if ("_zod" in v) return this.v4Layer.isDefault(v);
		else return this.v3Layer.isDefault(v);
	}
	isIntersection(v) {
		if ("_zod" in v) return this.v4Layer.isIntersection(v);
		else return this.v3Layer.isIntersection(v);
	}
	defaultZodObjectHandler(value, options = { passthrough: true }) {
		if ("_zod" in value) return this.v4Layer.defaultZodObjectHandler(value, options);
		else return this.v3Layer.defaultZodObjectHandler(value, options);
	}
	mergeParameterDescription(description, constraints) {
		return this.v3Layer.mergeParameterDescription(description, constraints);
	}
	defaultUnsupportedZodTypeHandler(value, throwOnTypes) {
		if ("_zod" in value) return this.v4Layer.defaultUnsupportedZodTypeHandler(value, throwOnTypes ?? UNSUPPORTED_ZOD_TYPES$2);
		else return this.v3Layer.defaultUnsupportedZodTypeHandler(value, throwOnTypes ?? UNSUPPORTED_ZOD_TYPES);
	}
	defaultZodArrayHandler(value, handleChecks = ALL_ARRAY_CHECKS) {
		if ("_zod" in value) return this.v4Layer.defaultZodArrayHandler(value, handleChecks);
		else return this.v3Layer.defaultZodArrayHandler(value, handleChecks);
	}
	defaultZodUnionHandler(value) {
		if ("_zod" in value) return this.v4Layer.defaultZodUnionHandler(value);
		else return this.v3Layer.defaultZodUnionHandler(value);
	}
	defaultZodStringHandler(value, handleChecks = ALL_STRING_CHECKS) {
		if ("_zod" in value) return this.v4Layer.defaultZodStringHandler(value);
		else return this.v3Layer.defaultZodStringHandler(value, handleChecks);
	}
	defaultZodNumberHandler(value, handleChecks = ALL_NUMBER_CHECKS) {
		if ("_zod" in value) return this.v4Layer.defaultZodNumberHandler(value);
		else return this.v3Layer.defaultZodNumberHandler(value, handleChecks);
	}
	defaultZodDateHandler(value) {
		if ("_zod" in value) return this.v4Layer.defaultZodDateHandler(value);
		else return this.v3Layer.defaultZodDateHandler(value);
	}
	defaultZodOptionalHandler(value, handleTypes) {
		if (!handleTypes) handleTypes = [
			"ZodObject",
			"ZodArray",
			"ZodUnion",
			"ZodString",
			"ZodNumber"
		];
		let innerTypeName;
		if ("_zod" in value) {
			const v4Type = (value._zod?.def?.innerType)?._zod?.def?.type;
			if (!v4Type) return value;
			innerTypeName = "Zod" + v4Type.charAt(0).toUpperCase() + v4Type.slice(1);
		} else innerTypeName = value._def.innerType._def.typeName;
		if (handleTypes.includes(innerTypeName)) if ("_zod" in value) {
			const innerType = value._zod?.def?.innerType;
			if (!innerType) return value;
			return this.processZodType(innerType).optional();
		} else return this.processZodType(value._def.innerType).optional();
		else return value;
	}
	defaultZodNullableHandler(value, handleTypes) {
		if ("_zod" in value) return this.v4Layer.defaultZodNullableHandler(value, handleTypes ?? SUPPORTED_ZOD_TYPES$2);
		else return this.v3Layer.defaultZodNullableHandler(value, handleTypes ?? SUPPORTED_ZOD_TYPES);
	}
	defaultZodIntersectionHandler(value) {
		if ("_zod" in value) return this.v4Layer.defaultZodIntersectionHandler(value);
		else return this.v3Layer.defaultZodIntersectionHandler(value);
	}
	/**
	* @deprecated please use processToCompatSchema to usse StandardSchemaWithJSON
	* @param zodSchema
	* @returns
	*/
	processToAISDKSchema(zodSchema) {
		return convertZodSchemaToAISDKSchema(this.processZodType(zodSchema), this.getSchemaTarget());
	}
	/**
	* @param schema
	* @returns
	*/
	processToJSONSchema(schema, io = "input") {
		const jsonSchema = standardSchemaToJSONSchema(toStandardSchema(schema), {
			target: "draft-07",
			io
		});
		(0, import_json_schema_traverse.default)(jsonSchema, { cb: {
			pre: (schema) => {
				this.preProcessJSONNode(schema);
			},
			post: (schema) => {
				this.postProcessJSONNode(schema);
			}
		} });
		return jsonSchema;
	}
	processToCompatSchema(schema) {
		return { "~standard": {
			version: 1,
			vendor: "mastra",
			validate: (value) => toStandardSchema(schema)["~standard"].validate(value),
			jsonSchema: {
				input: () => {
					return this.processToJSONSchema(schema, "input");
				},
				output: () => {
					return this.processToJSONSchema(schema, "output");
				}
			}
		} };
	}
	/**
	* Default handler for JSON Schema objects.
	* Processes object schemas with properties and required fields.
	*/
	defaultObjectHandler(schema) {
		if (schema.properties && schema.additionalProperties === void 0) schema.additionalProperties = false;
		if (!Object.keys(schema.properties ?? {}).length) schema.required = [];
		return schema;
	}
	/**
	* Default handler for JSON Schema arrays.
	* Converts array constraints (minItems, maxItems) to description text.
	*/
	defaultArrayHandler(schema) {
		let constraints = [];
		const minItems = schema.minItems;
		const maxItems = schema.maxItems;
		if (minItems !== void 0 && maxItems !== void 0 && minItems === maxItems) {
			constraints = [`exact length ${minItems}`];
			delete schema.minItems;
			delete schema.maxItems;
		} else {
			if (minItems !== void 0) {
				constraints.push(`minimum length ${minItems}`);
				delete schema.minItems;
			}
			if (maxItems !== void 0) {
				constraints.push(`maximum length ${maxItems}`);
				delete schema.maxItems;
			}
		}
		if (constraints.length) schema.description = this.mergeParameterDescription(schema.description, constraints);
		return schema;
	}
	/**
	* Default handler for JSON Schema strings.
	* Converts string constraints (minLength, maxLength, pattern, format) to description text.
	*/
	defaultStringHandler(schema) {
		const constraints = [];
		if (schema.minLength !== void 0) {
			constraints.push(`minimum length ${schema.minLength}`);
			delete schema.minLength;
		}
		if (schema.maxLength !== void 0) {
			constraints.push(`maximum length ${schema.maxLength}`);
			delete schema.maxLength;
		}
		switch (schema.format) {
			case "email":
			case "emoji":
			case "uri":
			case "uuid":
			case "date-time":
			case "date":
			case "time":
				constraints.push(`a valid ${schema.format}`);
				delete schema.pattern;
				delete schema.format;
				break;
		}
		if (constraints.length === 0 && schema.pattern !== void 0) {
			constraints.push(`input must match this regex ${schema.pattern}`);
			delete schema.pattern;
		}
		if (constraints.length) schema.description = this.mergeParameterDescription(schema.description, constraints);
		return schema;
	}
	/**
	* Default handler for JSON Schema numbers/integers.
	* Converts number constraints (minimum, maximum, multipleOf, exclusiveMinimum, exclusiveMaximum) to description text.
	*/
	defaultNumberHandler(schema) {
		const constraints = [];
		if (schema.minimum !== void 0) {
			if (schema.minimum !== Number.MIN_SAFE_INTEGER) constraints.push(`greater than or equal to ${schema.minimum}`);
			delete schema.minimum;
		}
		if (schema.maximum !== void 0) {
			if (schema.maximum !== Number.MAX_SAFE_INTEGER) constraints.push(`lower than or equal to ${schema.maximum}`);
			delete schema.maximum;
		}
		if (schema.exclusiveMinimum !== void 0) {
			constraints.push(`greater than ${schema.exclusiveMinimum}`);
			delete schema.exclusiveMinimum;
		}
		if (schema.exclusiveMaximum !== void 0) {
			constraints.push(`lower than ${schema.exclusiveMaximum}`);
			delete schema.exclusiveMaximum;
		}
		if (schema.multipleOf !== void 0) {
			constraints.push(`multiple of ${schema.multipleOf}`);
			delete schema.multipleOf;
		}
		if (constraints.length) schema.description = this.mergeParameterDescription(schema.description, constraints);
		return schema;
	}
	/**
	* Default handler for JSON Schema unions (anyOf/oneOf).
	* Processes union schemas and can convert anyOf patterns to type arrays for simple primitives.
	*/
	defaultUnionHandler(schema) {
		if (Array.isArray(schema.anyOf)) {
			schema.anyOf = schema.anyOf.map((subSchema) => {
				if (typeof subSchema !== "object" || subSchema === null) return false;
				this.preProcessJSONNode(subSchema);
				this.postProcessJSONNode(subSchema);
				return subSchema;
			}).filter(Boolean);
			if (schema.anyOf.length === 1) schema = schema.anyOf[0];
		}
		return schema;
	}
	/**
	* Default handler for JSON Schema allOf (intersection) types.
	* Flattens allOf sub-schemas by merging properties and required arrays into a single object schema.
	*/
	defaultAllOfHandler(schema) {
		if (!schema.allOf || !Array.isArray(schema.allOf)) return schema;
		const mergedProperties = {};
		const mergedRequired = [];
		for (const subSchema of schema.allOf) {
			if (subSchema.properties) Object.assign(mergedProperties, subSchema.properties);
			if (Array.isArray(subSchema.required)) mergedRequired.push(...subSchema.required);
		}
		delete schema.allOf;
		schema.type = "object";
		schema.properties = mergedProperties;
		if (mergedRequired.length > 0) schema.required = [...new Set(mergedRequired)];
		schema.additionalProperties = false;
		return schema;
	}
	/**
	* Default handler for JSON Schema nullable types.
	* Ensures nullable types are represented correctly.
	*/
	defaultNullableHandler(schema) {
		return this.defaultUnionHandler(schema);
	}
	/**
	* Default handler for JSON Schema dates (string with date/date-time format).
	* Converts date formats to string type with format constraint in description.
	*/
	defaultDateHandler(schema) {
		if (schema.format === "date" || schema.format === "date-time") {
			const format = schema.format;
			delete schema.format;
			schema.description = this.mergeParameterDescription(schema.description, [`format: ${format}`]);
		}
		return schema;
	}
	/**
	* Default handler for empty JSON schemas.
	* Converts empty {} schemas to a union of primitive types.
	*/
	defaultEmptySchemaHandler(schema) {
		if (Object.keys(schema).length === 0) schema.type = [
			"string",
			"number",
			"boolean",
			"null"
		];
		return schema;
	}
	/**
	* Default handler for unsupported JSON Schema features.
	* Can be used to strip or convert unsupported keywords.
	*/
	defaultUnsupportedHandler(schema, unsupportedKeywords = []) {
		for (const keyword of unsupportedKeywords) if (keyword in schema) delete schema[keyword];
		return schema;
	}
	isObjectSchema(schema) {
		return isObjectSchema(schema);
	}
	isArraySchema(schema) {
		return isArraySchema(schema);
	}
	isStringSchema(schema) {
		return isStringSchema(schema);
	}
	isNumberSchema(schema) {
		return isNumberSchema(schema);
	}
	isUnionSchema(schema) {
		return isUnionSchema(schema);
	}
	isAllOfSchema(schema) {
		return isAllOfSchema(schema);
	}
	/**
	* Checks if a property is optional within a parent object schema.
	* A property is optional if it's not in the parent's `required` array.
	* @param propertyName - The name of the property to check
	* @param parentSchema - The parent object schema containing the property
	*/
	isOptionalProperty(propertyName, parentSchema) {
		return isOptionalSchema(propertyName, parentSchema);
	}
	/**
	* Converts a Zod schema to JSON Schema using the standard-schema interface
	* and applies pre/post processing via traverse.
	*
	* Uses 'input' io mode so that fields with defaults are optional (appropriate for tool parameters).
	* @deprecated please use processToCompatSchema
	*/
	toJSONSchema(zodSchema) {
		const SCHEMA_TARGET_TO_STANDARD = {
			jsonSchema7: "draft-07",
			"jsonSchema2019-09": "draft-2020-12",
			openApi3: "openapi-3.0"
		};
		const schemaTarget = this.getSchemaTarget();
		const target = (schemaTarget && SCHEMA_TARGET_TO_STANDARD[schemaTarget]) ?? schemaTarget;
		const jsonSchema = standardSchemaToJSONSchema(toStandardSchema(zodSchema), {
			target,
			io: "input"
		});
		(0, import_json_schema_traverse.default)(jsonSchema, { cb: {
			pre: (schema) => {
				this.preProcessJSONNode(schema);
			},
			post: (schema) => {
				this.postProcessJSONNode(schema);
			}
		} });
		return jsonSchema;
	}
};
//#endregion
//#region src/null-to-undefined.ts
/**
* Recursively converts null values to undefined in an object based on which
* properties are optional in the JSON Schema. This is needed because OpenAI
* strict mode sends null for optional fields, but schemas like Zod's .optional()
* reject null.
*
* Only converts null→undefined for properties that are NOT in the schema's
* `required` array, preserving null for explicitly .nullable() fields.
*/
function transformNullToUndefined(value, jsonSchema) {
	if (value === null || value === void 0) return value;
	if (typeof value !== "object" || Array.isArray(value)) {
		if (Array.isArray(value) && jsonSchema.items && typeof jsonSchema.items === "object") return value.map((item) => transformNullToUndefined(item, jsonSchema.items));
		return value;
	}
	const properties = jsonSchema.properties;
	if (!properties) return value;
	const required = jsonSchema.required || [];
	const result = {};
	for (const [key, val] of Object.entries(value)) if (val === null && !required.includes(key)) result[key] = void 0;
	else if (val !== null && typeof val === "object" && properties[key]) result[key] = transformNullToUndefined(val, properties[key]);
	else result[key] = val;
	return result;
}
/**
* Wraps a StandardSchemaWithJSON to transform null values to undefined for
* optional fields before validation. This is a schema-agnostic solution for
* OpenAI strict mode, which sends null for optional fields.
*
* The wrapper:
* 1. Extracts the JSON Schema from the inner schema to determine optional fields
* 2. Before validation, transforms null→undefined for non-required properties
* 3. Delegates validation to the inner schema with the transformed value
* 4. Delegates JSON Schema conversion to the inner schema unchanged
*/
function wrapSchemaWithNullTransform(schema) {
	let jsonSchema;
	try {
		jsonSchema = schema["~standard"].jsonSchema.input({ target: "draft-07" });
	} catch {}
	if (!jsonSchema) return schema;
	const innerProps = schema["~standard"];
	return { "~standard": {
		version: innerProps.version,
		vendor: innerProps.vendor,
		types: innerProps.types,
		validate: (value, options) => {
			const transformed = transformNullToUndefined(value, jsonSchema);
			return innerProps.validate(transformed, options);
		},
		jsonSchema: innerProps.jsonSchema
	} };
}
function isOptional$1(z) {
	return (v) => v instanceof z["ZodOptional"];
}
function isObj$1(z) {
	return (v) => v instanceof z["ZodObject"];
}
function isNull(z) {
	return (v) => v instanceof z["ZodNull"];
}
function isArr$1(z) {
	return (v) => v instanceof z["ZodArray"];
}
function isUnion$1(z) {
	return (v) => v instanceof z["ZodUnion"];
}
function isString$1(z) {
	return (v) => v instanceof z["ZodString"];
}
function isNumber$1(z) {
	return (v) => v instanceof z["ZodNumber"];
}
function isDate(z) {
	return (v) => v instanceof z["ZodDate"];
}
function isDefault(z) {
	return (v) => v instanceof z["ZodDefault"];
}
function isNullable(z) {
	return (v) => v instanceof z["ZodNullable"];
}
function isIntersection(z) {
	return (v) => v instanceof z["ZodIntersection"];
}
//#endregion
//#region src/provider-compats/openai.ts
const allowedStringFormats = [
	"date-time",
	"time",
	"date",
	"duration",
	"email",
	"hostname",
	"ipv4",
	"ipv6",
	"uuid"
];
var OpenAISchemaCompatLayer = class extends SchemaCompatLayer {
	getSchemaTarget() {
		return `jsonSchema7`;
	}
	isReasoningModel() {
		const modelId = this.getModel().modelId;
		if (!modelId) return false;
		return modelId.includes(`o3`) || modelId.includes(`o4`) || modelId.includes(`o1`);
	}
	shouldApply() {
		const model = this.getModel();
		if (!this.isReasoningModel() && (model.provider.includes(`openai`) || model.modelId?.includes(`openai`) || model.provider.includes(`groq`))) return true;
		return false;
	}
	processZodType(value) {
		if (isOptional$1(z$1)(value)) {
			const innerType = "_def" in value ? value._def.innerType : value._zod?.def?.innerType;
			if (innerType) {
				if (isNullable(z$1)(innerType)) return this.processZodType(innerType).transform((val) => val === null ? void 0 : val);
				return this.processZodType(innerType).nullable().transform((val) => val === null ? void 0 : val);
			}
			return value;
		} else if (isNullable(z$1)(value)) {
			const innerType = "_def" in value ? value._def.innerType : value._zod?.def?.innerType;
			if (innerType) {
				if (isOptional$1(z$1)(innerType)) {
					const innerInnerType = "_def" in innerType ? innerType._def.innerType : innerType._zod?.def?.innerType;
					if (innerInnerType) return this.processZodType(innerInnerType).nullable().transform((val) => val === null ? void 0 : val);
				}
				return this.processZodType(innerType).nullable();
			}
			return value;
		} else if (isDefault(z$1)(value)) {
			const innerType = "_def" in value ? value._def.innerType : value._zod?.def?.innerType;
			const defaultValue = "_def" in value ? value._def.defaultValue : value._zod?.def?.defaultValue;
			if (innerType) return this.processZodType(innerType).nullable().transform((val) => {
				if (val === null) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
				return val;
			});
			return value;
		} else if (isObj$1(z$1)(value)) return this.defaultZodObjectHandler(value);
		else if (isUnion$1(z$1)(value)) return this.defaultZodUnionHandler(value);
		else if (isArr$1(z$1)(value)) return this.defaultZodArrayHandler(value);
		else if (isString$1(z$1)(value)) {
			const model = this.getModel();
			const checks = ["emoji"];
			if (model.modelId?.includes("gpt-4o-mini")) return this.defaultZodStringHandler(value, ["emoji", "regex"]);
			return this.defaultZodStringHandler(value, checks);
		}
		if (isIntersection(z$1)(value)) return this.defaultZodIntersectionHandler(value);
		return this.defaultUnsupportedZodTypeHandler(value, [
			"ZodNever",
			"ZodUndefined",
			"ZodTuple"
		]);
	}
	/**
	* Override to apply the same JSON Schema fixes (additionalProperties, required fields)
	* that processToJSONSchema applies. The base implementation skips JSON Schema traversal,
	* which causes OpenAI strict mode to reject tool schemas missing additionalProperties: false.
	*/
	processToAISDKSchema(zodSchema) {
		const transformedJsonSchema = standardSchemaToJSONSchema(this.processToCompatSchema(zodSchema));
		return jsonSchema(transformedJsonSchema, { validate: (value) => {
			const transformed = this.#traverse(value, transformedJsonSchema);
			const result = zodSchema.safeParse(transformed);
			return result.success ? {
				success: true,
				value: result.data
			} : {
				success: false,
				error: result.error
			};
		} });
	}
	processToCompatSchema(schema) {
		const originalStandardSchema = toStandardSchema(schema);
		return { "~standard": {
			version: 1,
			vendor: "mastra",
			validate: (value) => {
				const transformedJsonSchema = this.processToJSONSchema(schema, "input");
				const transformed = this.#traverse(value, transformedJsonSchema);
				return originalStandardSchema["~standard"].validate(transformed);
			},
			jsonSchema: {
				input: () => {
					return this.processToJSONSchema(schema, "input");
				},
				output: () => {
					return this.processToJSONSchema(schema, "output");
				}
			}
		} };
	}
	preProcessJSONNode(schema, _parentSchema) {
		if (isAllOfSchema(schema)) this.defaultAllOfHandler(schema);
		if (isObjectSchema(schema)) this.defaultObjectHandler(schema);
		else if (isArraySchema(schema)) this.defaultArrayHandler(schema);
		else if (isNumberSchema(schema)) this.defaultNumberHandler(schema);
		else if (isStringSchema(schema)) {
			if (schema.format) {
				if (!allowedStringFormats.includes(schema.format)) {
					delete schema.format;
					delete schema.pattern;
				}
			}
			this.defaultStringHandler(schema);
		}
	}
	postProcessJSONNode(schema) {
		if (isUnionSchema(schema)) this.defaultUnionHandler(schema);
		if (schema.type === void 0 && !schema.anyOf) {
			let subSchema = {};
			for (const key of Object.keys(schema)) {
				subSchema[key] = schema[key];
				delete schema[key];
			}
			schema.anyOf = [subSchema, { type: "null" }];
		}
		if (isObjectSchema(schema)) {
			schema.additionalProperties = false;
			delete schema.propertyNames;
			if (schema.properties) for (const key of Object.keys(schema.properties)) {
				const prop = schema.properties[key];
				if (!schema.required) schema.required = [];
				if (!schema.required?.includes(key)) {
					schema["x-optional"] = [...schema["x-optional"] || [], key];
					schema.required?.push(key);
					if (prop.type) {
						if (Array.isArray(prop.type)) {
							const types = [...prop.type];
							if (!types.includes("null")) types.push("null");
							const propSchema = { ...prop };
							delete propSchema.anyOf;
							delete propSchema.type;
							delete prop.type;
							prop.anyOf = types.map((type) => type === "null" ? { type: "null" } : {
								...propSchema,
								type
							});
						} else if (prop.type !== "null") {
							const originalType = prop.type;
							const propSchema = { ...prop };
							delete propSchema.anyOf;
							delete propSchema.type;
							delete prop.type;
							prop.anyOf = [{
								...propSchema,
								type: originalType
							}, { type: "null" }];
						}
					}
				}
			}
		}
	}
	#traverse(value, schema) {
		const resolved = this.#resolveAnyOf(schema);
		if ((isDateFormat(resolved) || resolved["x-date"] === true) && typeof value === "string") return new Date(value);
		if (resolved.type === "array" || Array.isArray(resolved.type) && resolved.type.includes("array")) {
			if (!Array.isArray(value)) return value;
			return value.map((item) => this.#traverse(item, resolved.items));
		}
		if (!(resolved.type === "object" || Array.isArray(resolved.type) && resolved.type.includes("object"))) return value;
		const properties = resolved.properties;
		if (!properties || !value) return value;
		const obj = value;
		const optionalProperties = resolved["x-optional"] ?? [];
		for (const key in obj) if (optionalProperties.includes(key) && obj[key] === null) obj[key] = void 0;
		else if (properties[key]) obj[key] = this.#traverse(obj[key], properties[key]);
		return obj;
	}
	/**
	* If schema has anyOf, return the first non-null variant for traversal.
	* Otherwise return the schema itself.
	*/
	#resolveAnyOf(schema) {
		if (Array.isArray(schema.anyOf)) {
			const nonNull = schema.anyOf.find((s) => s.type !== "null");
			if (nonNull) return nonNull;
		}
		return schema;
	}
};
function isDateFormat(schema) {
	return schema.format === "date-time" || schema.format === "date";
}
//#endregion
//#region src/provider-compats/openai-reasoning.ts
var OpenAIReasoningSchemaCompatLayer = class extends OpenAISchemaCompatLayer {
	getSchemaTarget() {
		return `openApi3`;
	}
	isReasoningModel() {
		const modelId = this.getModel().modelId;
		if (!modelId) return false;
		return modelId.includes(`o3`) || modelId.includes(`o4`) || modelId.includes(`o1`);
	}
	shouldApply() {
		const model = this.getModel();
		if (this.isReasoningModel() && (model.provider.includes(`openai`) || model.modelId?.includes(`openai`))) return true;
		return false;
	}
	processZodType(value) {
		if (isOptional$1(z$1)(value)) {
			const innerType = "_def" in value ? value._def.innerType : value._zod?.def?.innerType;
			if (innerType) {
				if (isNullable(z$1)(innerType)) return this.processZodType(innerType).transform((val) => val === null ? void 0 : val);
				return this.processZodType(innerType).nullable().transform((val) => val === null ? void 0 : val);
			}
			return value;
		} else if (isNullable(z$1)(value)) {
			const innerType = "_def" in value ? value._def.innerType : value._zod?.def?.innerType;
			if (innerType && isOptional$1(z$1)(innerType)) {
				const innerInnerType = "_def" in innerType ? innerType._def.innerType : innerType._zod?.def?.innerType;
				if (innerInnerType) return this.processZodType(innerInnerType).nullable().transform((val) => val === null ? void 0 : val);
			}
			if (innerType) return this.processZodType(innerType).nullable();
			return value;
		} else if (isObj$1(z$1)(value)) return this.defaultZodObjectHandler(value, { passthrough: false });
		else if (isArr$1(z$1)(value)) return this.defaultZodArrayHandler(value);
		else if (isUnion$1(z$1)(value)) return this.defaultZodUnionHandler(value);
		else if (isDefault(z$1)(value)) {
			const defaultDef = value._def;
			const innerType = defaultDef.innerType;
			const defaultValue = typeof defaultDef.defaultValue === "function" ? defaultDef.defaultValue() : defaultDef.defaultValue;
			const constraints = [];
			if (defaultValue !== void 0) constraints.push(`the default value is ${defaultValue}`);
			const description = this.mergeParameterDescription(value.description, constraints);
			let result = this.processZodType(innerType);
			if (description) result = result.describe(description);
			return result;
		} else if (isNumber$1(z$1)(value)) return this.defaultZodNumberHandler(value);
		else if (isString$1(z$1)(value)) return this.defaultZodStringHandler(value);
		else if (isDate(z$1)(value)) return this.defaultZodDateHandler(value);
		else if (isNull(z$1)(value)) return z$1.any().refine((v) => v === null, { message: "must be null" }).describe(value.description || "must be null");
		else if (value.constructor.name === "ZodAny") return z$1.string().describe((value.description ?? "") + `\nArgument was an "any" type, but you (the LLM) do not support "any", so it was cast to a "string" type`);
		if (isIntersection(z$1)(value)) return this.defaultZodIntersectionHandler(value);
		return this.defaultUnsupportedZodTypeHandler(value);
	}
};
//#endregion
//#region src/standard-schema-compat.ts
/**
* Standard Schema compatibility utilities
*
* This module provides utilities to apply provider-specific schema transformations
* to StandardSchemaWithJSON types, particularly for OpenAI compatibility.
*/
/**
* Extracts the underlying Zod schema from a schema value.
*
* Handles both:
* - Raw Zod schemas (z.object(...))
* - StandardSchemaWithJSON wrappers that preserve Zod methods via prototype
*
* @param schema - The schema to extract from
* @returns The underlying Zod schema, or null if not a Zod schema
*/
function extractZodSchema(schema) {
	if (!isZodType(schema)) return null;
	return schema;
}
/**
* Applies OpenAI schema compatibility transforms to a schema.
*
* For OpenAI models, converts `.optional()` fields to `.nullable().transform()`
* to work around OpenAI's limitation with optional fields in structured outputs.
*
* @param schema - The schema to process (raw Zod or StandardSchemaWithJSON)
* @param modelInfo - Information about the target model
* @returns The processed schema as StandardSchemaWithJSON, or original if not applicable
*
* @example
* ```typescript
* const schema = z.object({
*   name: z.string(),
*   age: z.number().optional(), // Will be converted to .nullable().transform()
* });
*
* const processed = applyOpenAICompatTransforms(schema, {
*   provider: 'openai',
*   modelId: 'gpt-4',
*   supportsStructuredOutputs: false,
* });
* ```
*/
function applyOpenAICompatTransforms(schema, modelInfo) {
	if (!(modelInfo.provider?.includes("openai") || modelInfo.modelId?.includes("openai"))) return schema;
	const zodSchema = extractZodSchema(schema);
	if (!zodSchema) return schema;
	const compatLayer = /^o[1-5]/.test(modelInfo.modelId) ? new OpenAIReasoningSchemaCompatLayer(modelInfo) : new OpenAISchemaCompatLayer(modelInfo);
	if (!compatLayer.shouldApply()) return schema;
	return toStandardSchema(compatLayer.processZodType(zodSchema));
}
/**
* Applies OpenAI compat transforms to all tools in a toolset.
*
* Processes each tool's inputSchema (if present) with OpenAI compatibility transforms.
*
* @param tools - The toolset to process
* @param modelInfo - Information about the target model
* @returns The processed toolset with transformed schemas
*
* @example
* ```typescript
* const tools = {
*   getTodo: {
*     inputSchema: z.object({
*       id: z.string(),
*       includeCompleted: z.boolean().optional(), // Will be transformed
*     }),
*     execute: async (input) => { ... },
*   },
* };
*
* const processed = applyOpenAICompatToTools(tools, {
*   provider: 'openai',
*   modelId: 'gpt-4',
*   supportsStructuredOutputs: false,
* });
* ```
*/
function applyOpenAICompatToTools(tools, modelInfo) {
	if (!tools) return tools;
	const transformedTools = {};
	for (const [name, tool] of Object.entries(tools)) if (tool.inputSchema) {
		const processedSchema = applyOpenAICompatTransforms(tool.inputSchema, modelInfo);
		transformedTools[name] = {
			...tool,
			inputSchema: processedSchema
		};
	} else transformedTools[name] = tool;
	return transformedTools;
}
//#endregion
//#region src/provider-compats/anthropic.ts
var AnthropicSchemaCompatLayer = class extends SchemaCompatLayer {
	constructor(model) {
		super(model);
	}
	getSchemaTarget() {
		return "jsonSchema7";
	}
	processToJSONSchema(schema, io = "input") {
		const jsonSchema = super.processToJSONSchema(schema, io);
		const union = jsonSchema.anyOf ?? jsonSchema.oneOf;
		if (io !== "input" || !Array.isArray(union)) return jsonSchema;
		const objectSchemas = union.filter((subSchema) => typeof subSchema === "object" && subSchema !== null && subSchema.type === "object");
		if (objectSchemas.length === 0 || objectSchemas.length !== union.length) return jsonSchema;
		delete jsonSchema.anyOf;
		delete jsonSchema.oneOf;
		jsonSchema.type = "object";
		const mergedProperties = {};
		for (const subSchema of objectSchemas) for (const [key, propSchema] of Object.entries(subSchema.properties ?? {})) {
			const variants = mergedProperties[key] ??= [];
			if (!variants.some((existing) => JSON.stringify(existing) === JSON.stringify(propSchema))) variants.push(propSchema);
		}
		jsonSchema.properties = Object.fromEntries(Object.entries(mergedProperties).map(([key, variants]) => [key, variants.length === 1 ? variants[0] : { anyOf: variants }]));
		jsonSchema.required = objectSchemas.map((subSchema) => subSchema.required ?? []).reduce((required, branchRequired) => required.filter((key) => branchRequired.includes(key)));
		jsonSchema.additionalProperties = false;
		return jsonSchema;
	}
	shouldApply() {
		return this.getModel().modelId.includes("claude");
	}
	processZodType(value) {
		if (this.isOptional(value)) {
			const handleTypes = [
				"ZodObject",
				"ZodArray",
				"ZodUnion",
				"ZodNever",
				"ZodUndefined",
				"ZodTuple"
			];
			if (this.getModel().modelId.includes("claude-3.5-haiku")) handleTypes.push("ZodString");
			return this.defaultZodOptionalHandler(value, handleTypes);
		} else if (this.isObj(value)) return this.defaultZodObjectHandler(value);
		else if (this.isArr(value)) return this.defaultZodArrayHandler(value, []);
		else if (this.isUnion(value)) return this.defaultZodUnionHandler(value);
		else if (this.isString(value)) if (this.getModel().modelId.includes("claude-3.5-haiku")) return this.defaultZodStringHandler(value, ["max", "min"]);
		else return value;
		else if (isNull(z$1)(value)) return z$1.any().refine((v) => v === null, { message: "must be null" }).describe(value.description || "must be null");
		else if (isIntersection(z$1)(value)) return this.defaultZodIntersectionHandler(value);
		return this.defaultUnsupportedZodTypeHandler(value);
	}
	processToAISDKSchema(zodSchema) {
		const compat = this.processToCompatSchema(zodSchema);
		return jsonSchema(standardSchemaToJSONSchema(compat), { validate: (value) => {
			const result = compat["~standard"].validate(value);
			if (result instanceof Promise) throw new Error("Async validation is not supported");
			return "issues" in result && result.issues ? {
				success: false,
				error: new Error(result.issues.map((i) => i.message).join(", "))
			} : {
				success: true,
				value: result.value
			};
		} });
	}
	processToCompatSchema(schema) {
		const originalStandardSchema = toStandardSchema(schema);
		const validationStandardSchema = this.#getCompatValidationStandardSchema(schema, originalStandardSchema);
		return { "~standard": {
			version: 1,
			vendor: "mastra",
			validate: (value) => {
				const transformedJsonSchema = this.processToJSONSchema(schema, "input");
				const transformed = this.#traverse(value, transformedJsonSchema);
				return validationStandardSchema["~standard"].validate(transformed);
			},
			jsonSchema: {
				input: () => {
					return this.processToJSONSchema(schema, "input");
				},
				output: () => {
					return this.processToJSONSchema(schema, "output");
				}
			}
		} };
	}
	preProcessJSONNode(schema) {
		if (isAllOfSchema(schema)) this.defaultAllOfHandler(schema);
		if (isObjectSchema(schema)) this.defaultObjectHandler(schema);
		else if (isArraySchema(schema)) this.defaultArrayHandler(schema);
		else if (isNumberSchema(schema)) this.defaultNumberHandler(schema);
		else if (isStringSchema(schema)) this.defaultStringHandler(schema);
	}
	postProcessJSONNode(schema) {
		if (isUnionSchema(schema)) this.defaultUnionHandler(schema);
	}
	#traverse(value, schema) {
		const resolved = this.#resolveSchemaForValue(schema, value);
		if (resolved["x-date"] === true && typeof value === "string") return new Date(value);
		if (resolved.type === "array" || Array.isArray(resolved.type) && resolved.type.includes("array")) {
			if (!Array.isArray(value)) return value;
			return value.map((item) => this.#traverse(item, resolved.items));
		}
		if (!(resolved.type === "object" || Array.isArray(resolved.type) && resolved.type.includes("object"))) return value;
		const properties = resolved.properties;
		if (!properties || !value) return value;
		const obj = value;
		for (const key in obj) if (properties[key]) obj[key] = this.#traverse(obj[key], properties[key]);
		return obj;
	}
	#isHaikuModel() {
		return this.getModel().modelId.includes("claude-3.5-haiku");
	}
	#getCompatValidationStandardSchema(schema, originalStandardSchema) {
		if (!this.#isHaikuModel() || !isZodType(schema)) return originalStandardSchema;
		return toStandardSchema(this.#stripHaikuStringLengthConstraints(schema));
	}
	/**
	* Strip Haiku-ignored string min/max from a Zod schema for execute-time validation.
	* Preserves object-level refinements and wrapper semantics unlike full-tree processZodType.
	*/
	#stripHaikuStringLengthConstraints(value) {
		const schemas = /* @__PURE__ */ new WeakMap();
		if ("_zod" in value) return this.#stripHaikuStringLengthConstraintsV4(value, schemas);
		return this.#stripHaikuStringLengthConstraintsV3(value, schemas);
	}
	#stripHaikuStringLengthConstraintsV4(value, schemas) {
		const cached = schemas.get(value);
		if (cached) return cached;
		const schema = value;
		const def = schema._zod.def;
		const strip = (child) => this.#stripHaikuStringLengthConstraintsV4(child, schemas);
		let nextDef = def;
		const replace = (key) => {
			const current = def[key];
			if (!current) return;
			const stripped = strip(current);
			if (stripped !== current) nextDef = {
				...nextDef,
				[key]: stripped
			};
		};
		switch (def.type) {
			case "string": {
				const checks = (def.checks ?? []).filter((check) => check._zod.def.check !== "min_length" && check._zod.def.check !== "max_length");
				if (checks.length !== (def.checks?.length ?? 0)) nextDef = {
					...def,
					checks
				};
				break;
			}
			case "object": {
				const shape = def.shape;
				const nextShape = Object.fromEntries(Object.entries(shape).map(([key, child]) => [key, strip(child)]));
				if (Object.keys(shape).some((key) => nextShape[key] !== shape[key])) nextDef = {
					...nextDef,
					shape: nextShape
				};
				replace("catchall");
				break;
			}
			case "array":
				replace("element");
				break;
			case "union": {
				const options = def.options;
				const nextOptions = options.map(strip);
				if (nextOptions.some((option, index) => option !== options[index])) nextDef = {
					...nextDef,
					options: nextOptions
				};
				break;
			}
			case "intersection":
				replace("left");
				replace("right");
				break;
			case "tuple": {
				const items = def.items;
				const nextItems = items.map(strip);
				if (nextItems.some((item, index) => item !== items[index])) nextDef = {
					...nextDef,
					items: nextItems
				};
				replace("rest");
				break;
			}
			case "record":
			case "map":
				replace("keyType");
				replace("valueType");
				break;
			case "set":
				replace("valueType");
				break;
			case "optional":
			case "nullable":
			case "default":
			case "prefault":
			case "nonoptional":
			case "success":
			case "catch":
			case "readonly":
				replace("innerType");
				break;
			case "pipe":
				replace("in");
				replace("out");
				break;
			case "promise":
				replace("innerType");
				break;
			case "lazy":
				nextDef = {
					...def,
					getter: () => strip(def.getter())
				};
				break;
		}
		if (nextDef === def) {
			schemas.set(value, value);
			return value;
		}
		let stripped = schema.clone(nextDef);
		const metadata = schema.meta();
		if (metadata) stripped = stripped.meta(metadata);
		schemas.set(value, stripped);
		return stripped;
	}
	#stripHaikuStringLengthConstraintsV3(value, schemas) {
		const cached = schemas.get(value);
		if (cached) return cached;
		const schema = value;
		const def = schema._def;
		const strip = (child) => this.#stripHaikuStringLengthConstraintsV3(child, schemas);
		let nextDef = def;
		const replace = (key) => {
			const current = def[key];
			if (!current) return;
			const stripped = strip(current);
			if (stripped !== current) nextDef = {
				...nextDef,
				[key]: stripped
			};
		};
		switch (def.typeName) {
			case "ZodString": {
				const checks = (def.checks ?? []).filter((check) => check.kind !== "min" && check.kind !== "max");
				if (checks.length !== (def.checks?.length ?? 0)) nextDef = {
					...def,
					checks
				};
				break;
			}
			case "ZodObject": {
				const shape = def.shape();
				const nextShape = Object.fromEntries(Object.entries(shape).map(([key, child]) => [key, strip(child)]));
				if (Object.keys(shape).some((key) => nextShape[key] !== shape[key])) nextDef = {
					...nextDef,
					shape: () => nextShape
				};
				replace("catchall");
				break;
			}
			case "ZodArray":
			case "ZodPromise":
			case "ZodBranded":
				replace("type");
				break;
			case "ZodUnion": {
				const options = def.options;
				const nextOptions = options.map(strip);
				if (nextOptions.some((option, index) => option !== options[index])) nextDef = {
					...nextDef,
					options: nextOptions
				};
				break;
			}
			case "ZodDiscriminatedUnion": {
				const options = def.options;
				const nextOptions = options.map(strip);
				if (nextOptions.some((option, index) => option !== options[index])) {
					const optionsMap = new Map(def.optionsMap);
					for (const [key, option] of optionsMap) {
						const index = options.indexOf(option);
						if (index !== -1) optionsMap.set(key, nextOptions[index]);
					}
					nextDef = {
						...nextDef,
						options: nextOptions,
						optionsMap
					};
				}
				break;
			}
			case "ZodIntersection":
				replace("left");
				replace("right");
				break;
			case "ZodTuple": {
				const items = def.items;
				const nextItems = items.map(strip);
				if (nextItems.some((item, index) => item !== items[index])) nextDef = {
					...nextDef,
					items: nextItems
				};
				replace("rest");
				break;
			}
			case "ZodRecord":
			case "ZodMap":
				replace("keyType");
				replace("valueType");
				break;
			case "ZodSet":
				replace("valueType");
				break;
			case "ZodOptional":
			case "ZodNullable":
			case "ZodDefault":
			case "ZodCatch":
			case "ZodReadonly":
				replace("innerType");
				break;
			case "ZodEffects":
				replace("schema");
				break;
			case "ZodPipeline":
				replace("in");
				replace("out");
				break;
			case "ZodLazy":
				nextDef = {
					...def,
					getter: () => strip(def.getter())
				};
				break;
		}
		if (nextDef === def) {
			schemas.set(value, value);
			return value;
		}
		const stripped = new schema.constructor(nextDef);
		schemas.set(value, stripped);
		return stripped;
	}
	#resolveSchemaForValue(schema, value) {
		if (!Array.isArray(schema.anyOf)) return schema;
		const variants = schema.anyOf;
		const nonNullVariants = variants.filter((variant) => variant.type !== "null");
		if (variants.length === 2 && nonNullVariants.length === 1) return nonNullVariants[0];
		const keys = value && typeof value === "object" ? Object.keys(value) : [];
		return nonNullVariants.find((variant) => {
			const properties = variant.properties;
			return !!properties && keys.some((key) => key in properties);
		}) ?? schema;
	}
};
//#endregion
//#region src/provider-compats/deepseek.ts
var DeepSeekSchemaCompatLayer = class extends SchemaCompatLayer {
	constructor(model) {
		super(model);
	}
	getSchemaTarget() {
		return "jsonSchema7";
	}
	shouldApply() {
		return this.getModel().modelId.includes("deepseek") && !this.getModel().modelId.includes("r1");
	}
	processZodType(value) {
		if (isOptional$1(z$1)(value)) return this.defaultZodOptionalHandler(value, [
			"ZodObject",
			"ZodArray",
			"ZodUnion",
			"ZodString",
			"ZodNumber"
		]);
		else if (isObj$1(z$1)(value)) return this.defaultZodObjectHandler(value);
		else if (isArr$1(z$1)(value)) return this.defaultZodArrayHandler(value, ["min", "max"]);
		else if (isUnion$1(z$1)(value)) return this.defaultZodUnionHandler(value);
		else if (isString$1(z$1)(value)) return this.defaultZodStringHandler(value);
		else if (isIntersection(z$1)(value)) return this.defaultZodIntersectionHandler(value);
		return value;
	}
	processToAISDKSchema(zodSchema) {
		const transformedJsonSchema = standardSchemaToJSONSchema(this.processToCompatSchema(zodSchema));
		return jsonSchema(transformedJsonSchema, { validate: (value) => {
			const transformed = this.#traverse(value, transformedJsonSchema);
			const result = zodSchema.safeParse(transformed);
			return result.success ? {
				success: true,
				value: result.data
			} : {
				success: false,
				error: result.error
			};
		} });
	}
	processToCompatSchema(schema) {
		const originalStandardSchema = toStandardSchema(schema);
		return { "~standard": {
			version: 1,
			vendor: "mastra",
			validate: (value) => {
				const transformedJsonSchema = this.processToJSONSchema(schema, "input");
				const transformed = this.#traverse(value, transformedJsonSchema);
				return originalStandardSchema["~standard"].validate(transformed);
			},
			jsonSchema: {
				input: () => {
					return this.processToJSONSchema(schema, "input");
				},
				output: () => {
					return this.processToJSONSchema(schema, "output");
				}
			}
		} };
	}
	preProcessJSONNode(schema) {
		if (isAllOfSchema(schema)) this.defaultAllOfHandler(schema);
		if (isObjectSchema(schema)) this.defaultObjectHandler(schema);
		else if (isArraySchema(schema)) this.defaultArrayHandler(schema);
		else if (isNumberSchema(schema)) this.defaultNumberHandler(schema);
		else if (isStringSchema(schema)) this.defaultStringHandler(schema);
	}
	postProcessJSONNode(schema) {
		if (isUnionSchema(schema)) this.defaultUnionHandler(schema);
	}
	#traverse(value, schema) {
		const resolved = this.#resolveAnyOf(schema);
		if (resolved["x-date"] === true && typeof value === "string") return new Date(value);
		if (resolved.type === "array" || Array.isArray(resolved.type) && resolved.type.includes("array")) {
			if (!Array.isArray(value)) return value;
			return value.map((item) => this.#traverse(item, resolved.items));
		}
		if (!(resolved.type === "object" || Array.isArray(resolved.type) && resolved.type.includes("object"))) return value;
		const properties = resolved.properties;
		if (!properties || !value) return value;
		const obj = value;
		for (const key in obj) if (properties[key]) obj[key] = this.#traverse(obj[key], properties[key]);
		return obj;
	}
	#resolveAnyOf(schema) {
		if (Array.isArray(schema.anyOf)) {
			const nonNull = schema.anyOf.find((s) => s.type !== "null");
			if (nonNull) return nonNull;
		}
		return schema;
	}
};
//#endregion
//#region src/provider-compats/google.ts
function fixAISDKNullableUnionTypes(schema) {
	if (typeof schema !== "object" || schema === null) return schema;
	const result = { ...schema };
	if (Array.isArray(result.type)) {
		const nonNullTypes = result.type.filter((t) => t !== "null");
		if (nonNullTypes.length === 1) {
			result.type = nonNullTypes[0];
			result.nullable = true;
		} else {
			delete result.type;
			delete result.nullable;
		}
	}
	if (Array.isArray(result.enum) && result.enum.some((value) => typeof value !== "string")) delete result.enum;
	if ("const" in result && typeof result.const !== "string") delete result.const;
	if (result.anyOf && Array.isArray(result.anyOf)) {
		const nullSchema = result.anyOf.find((s) => typeof s === "object" && s !== null && s.type === "null");
		const nonNullSchemas = result.anyOf.filter((s) => !(typeof s === "object" && s !== null && s.type === "null"));
		if (nullSchema) {
			const { anyOf: _, ...rest } = result;
			if (nonNullSchemas.length === 1 && typeof nonNullSchemas[0] === "object" && nonNullSchemas[0] !== null) {
				const fixedOther = fixAISDKNullableUnionTypes(nonNullSchemas[0]);
				return fixedOther.type ? {
					...rest,
					...fixedOther,
					nullable: true
				} : {
					...rest,
					...fixedOther
				};
			}
			return rest;
		}
	}
	if (result.properties && typeof result.properties === "object") result.properties = Object.fromEntries(Object.entries(result.properties).map(([key, value]) => [key, fixAISDKNullableUnionTypes(value)]));
	if (result.items) if (Array.isArray(result.items)) result.items = result.items.map((item) => fixAISDKNullableUnionTypes(item));
	else result.items = fixAISDKNullableUnionTypes(result.items);
	if (result.additionalProperties && typeof result.additionalProperties === "object") result.additionalProperties = fixAISDKNullableUnionTypes(result.additionalProperties);
	if (result.anyOf && Array.isArray(result.anyOf)) result.anyOf = result.anyOf.map((s) => fixAISDKNullableUnionTypes(s));
	if (result.oneOf && Array.isArray(result.oneOf)) result.oneOf = result.oneOf.map((s) => fixAISDKNullableUnionTypes(s));
	if (result.allOf && Array.isArray(result.allOf)) result.allOf = result.allOf.map((s) => fixAISDKNullableUnionTypes(s));
	if (result.anyOf && Array.isArray(result.anyOf)) {
		if (result.description) {
			for (const item of result.anyOf) if (typeof item === "object" && item !== null && !item.description) item.description = result.description;
		}
		return { anyOf: result.anyOf };
	}
	return result;
}
/**
* Inline `$ref` pointers one level and drop `definitions`/`$defs`.
* Gemini can't follow JSON Schema `$ref`s — they cause silent mis-fills.
* Self-references (recursive schemas) are collapsed to `{ type: 'object' }`
* to avoid infinite expansion.
*/
function inlineRefsAndDropDefinitions(schema) {
	const json = JSON.stringify(schema);
	if (!json.includes("\"$ref\"")) return;
	const defs = schema["definitions"] ?? schema["$defs"];
	const snapshot = JSON.parse(json);
	resolveRefs(schema, snapshot, snapshot["definitions"] ?? snapshot["$defs"] ?? defs ?? {}, /* @__PURE__ */ new Set());
	delete schema["definitions"];
	delete schema["$defs"];
}
function resolveRefs(node, rootSnapshot, defs, visiting) {
	if (typeof node !== "object" || node === null) return;
	for (const [key, value] of Object.entries(node)) if (key === "$ref" && typeof value === "string") {
		const resolved = resolveRef(value, rootSnapshot, defs);
		if (!resolved || visiting.has(value)) {
			delete node["$ref"];
			node["type"] = "object";
		} else {
			delete node["$ref"];
			visiting.add(value);
			const clone = JSON.parse(JSON.stringify(resolved));
			resolveRefs(clone, rootSnapshot, defs, visiting);
			visiting.delete(value);
			Object.assign(node, clone);
		}
	} else if (Array.isArray(value)) {
		for (const item of value) if (typeof item === "object" && item !== null) resolveRefs(item, rootSnapshot, defs, visiting);
	} else if (typeof value === "object" && value !== null) resolveRefs(value, rootSnapshot, defs, visiting);
}
function resolveRef(ref, rootSnapshot, defs) {
	if (ref === "#") return rootSnapshot;
	const match = ref.match(/^#\/(?:definitions|\$defs)\/(.+)$/);
	if (match) return defs[match[1]];
}
var GoogleSchemaCompatLayer = class extends SchemaCompatLayer {
	constructor(model) {
		super(model);
	}
	getSchemaTarget() {
		return "jsonSchema7";
	}
	shouldApply() {
		return this.getModel().provider.includes("google") || this.getModel().modelId.includes("gemini-") || this.getModel().modelId.includes("google");
	}
	processZodType(value) {
		if (isOptional$1(z$1)(value)) return this.defaultZodOptionalHandler(value, [
			"ZodObject",
			"ZodArray",
			"ZodUnion",
			"ZodString",
			"ZodNumber",
			"ZodNullable"
		]);
		else if (isNullable(z$1)(value)) return this.defaultZodNullableHandler(value);
		else if (isNull(z$1)(value)) return z$1.any().refine((v) => v === null, { message: "must be null" }).describe(value.description || "must be null");
		else if (isObj$1(z$1)(value)) return this.defaultZodObjectHandler(value);
		else if (isArr$1(z$1)(value)) return this.defaultZodArrayHandler(value, []);
		else if (isUnion$1(z$1)(value)) return this.defaultZodUnionHandler(value);
		else if (isString$1(z$1)(value)) return this.defaultZodStringHandler(value);
		else if (isNumber$1(z$1)(value)) return this.defaultZodNumberHandler(value);
		else if (isIntersection(z$1)(value)) return this.defaultZodIntersectionHandler(value);
		return this.defaultUnsupportedZodTypeHandler(value);
	}
	processToJSONSchema(schema, io) {
		const result = super.processToJSONSchema(schema, io);
		inlineRefsAndDropDefinitions(result);
		return result;
	}
	processToAISDKSchema(zodSchema) {
		const fixedJsonSchema = fixAISDKNullableUnionTypes(standardSchemaToJSONSchema(this.processToCompatSchema(zodSchema)));
		return jsonSchema(fixedJsonSchema, { validate: (value) => {
			const transformed = this.#traverse(value, fixedJsonSchema);
			const result = zodSchema.safeParse(transformed);
			return result.success ? {
				success: true,
				value: result.data
			} : {
				success: false,
				error: result.error
			};
		} });
	}
	processToCompatSchema(schema) {
		const originalStandardSchema = toStandardSchema(schema);
		return { "~standard": {
			version: 1,
			vendor: "mastra",
			validate: (value) => {
				const transformedJsonSchema = this.processToJSONSchema(schema, "input");
				const transformed = this.#traverse(value, transformedJsonSchema);
				return originalStandardSchema["~standard"].validate(transformed);
			},
			jsonSchema: {
				input: () => {
					return this.processToJSONSchema(schema, "input");
				},
				output: () => {
					return this.processToJSONSchema(schema, "output");
				}
			}
		} };
	}
	preProcessJSONNode(schema) {
		if (isAllOfSchema(schema)) this.defaultAllOfHandler(schema);
		if (isObjectSchema(schema)) this.defaultObjectHandler(schema);
		else if (isNumberSchema(schema)) this.defaultNumberHandler(schema);
		else if (isArraySchema(schema)) this.defaultArrayHandler(schema);
		else if (isStringSchema(schema)) this.defaultStringHandler(schema);
	}
	postProcessJSONNode(schema) {
		if (isUnionSchema(schema)) this.defaultUnionHandler(schema);
		const s = schema;
		delete s["$schema"];
		delete s["additionalProperties"];
		delete s["propertyNames"];
		if (Array.isArray(s["type"])) {
			const types = s["type"];
			const nonNull = types.filter((t) => t !== "null");
			const hasNull = types.includes("null");
			if (nonNull.length === 1) {
				s["type"] = nonNull[0];
				if (hasNull) s["nullable"] = true;
			} else if (nonNull.length === 0 && hasNull) {
				s["type"] = "object";
				s["nullable"] = true;
			} else {
				delete s["type"];
				s["anyOf"] = nonNull.map((t) => ({ type: t }));
				if (hasNull) s["nullable"] = true;
			}
		}
		if (Array.isArray(s["oneOf"])) {
			s["anyOf"] = s["oneOf"];
			delete s["oneOf"];
		}
		if ("const" in s) {
			s["enum"] = [s["const"]];
			delete s["const"];
		}
		if (Array.isArray(s["items"])) {
			s["items"] = { anyOf: s["items"] };
			delete s["minItems"];
			delete s["maxItems"];
		}
		if (Array.isArray(s["anyOf"])) {
			const variants = s["anyOf"];
			const nonNull = variants.filter((v) => v && typeof v === "object" && v["type"] !== "null");
			const hasNull = variants.some((v) => v && typeof v === "object" && v["type"] === "null");
			if (hasNull && nonNull.length === 1) {
				const base = nonNull[0];
				delete s["anyOf"];
				Object.assign(s, base);
				s["nullable"] = true;
			} else if (hasNull && nonNull.length > 1) {
				s["anyOf"] = nonNull;
				s["nullable"] = true;
			}
		}
		if (!s["type"] && !s["anyOf"] && !s["oneOf"] && !s["allOf"] && !s["$ref"] && !s["enum"] && !s["const"] && !s["properties"] && !s["items"]) {
			s["anyOf"] = [...[
				"string",
				"number",
				"integer",
				"boolean",
				"object"
			].map((t) => ({ type: t })), {
				type: "array",
				items: { anyOf: [
					"string",
					"number",
					"integer",
					"boolean",
					"object"
				].map((t) => ({ type: t })) }
			}];
			s["nullable"] = true;
		}
	}
	#traverse(value, schema) {
		const resolved = this.#resolveAnyOf(schema);
		if (resolved["x-date"] === true && typeof value === "string") return new Date(value);
		if (resolved.type === "array" || Array.isArray(resolved.type) && resolved.type.includes("array")) {
			if (!Array.isArray(value)) return value;
			return value.map((item) => this.#traverse(item, resolved.items));
		}
		if (!(resolved.type === "object" || Array.isArray(resolved.type) && resolved.type.includes("object"))) return value;
		const properties = resolved.properties;
		if (!properties || !value) return value;
		const obj = value;
		for (const key in obj) if (properties[key]) obj[key] = this.#traverse(obj[key], properties[key]);
		return obj;
	}
	#resolveAnyOf(schema) {
		if (Array.isArray(schema.anyOf)) {
			const nonNull = schema.anyOf.find((s) => s.type !== "null");
			if (nonNull) return nonNull;
		}
		return schema;
	}
};
//#endregion
//#region src/provider-compats/meta.ts
var MetaSchemaCompatLayer = class extends SchemaCompatLayer {
	constructor(model) {
		super(model);
	}
	getSchemaTarget() {
		return "jsonSchema7";
	}
	shouldApply() {
		return this.getModel().modelId.includes("meta");
	}
	processZodType(value) {
		if (isOptional$1(z$1)(value)) return this.defaultZodOptionalHandler(value, [
			"ZodObject",
			"ZodArray",
			"ZodUnion",
			"ZodString",
			"ZodNumber"
		]);
		else if (isObj$1(z$1)(value)) return this.defaultZodObjectHandler(value);
		else if (isArr$1(z$1)(value)) return this.defaultZodArrayHandler(value, ["min", "max"]);
		else if (isUnion$1(z$1)(value)) return this.defaultZodUnionHandler(value);
		else if (isNumber$1(z$1)(value)) return this.defaultZodNumberHandler(value);
		else if (isString$1(z$1)(value)) return this.defaultZodStringHandler(value);
		else if (isIntersection(z$1)(value)) return this.defaultZodIntersectionHandler(value);
		return value;
	}
	processToAISDKSchema(zodSchema) {
		const transformedJsonSchema = standardSchemaToJSONSchema(this.processToCompatSchema(zodSchema));
		return jsonSchema(transformedJsonSchema, { validate: (value) => {
			const transformed = this.#traverse(value, transformedJsonSchema);
			const result = zodSchema.safeParse(transformed);
			return result.success ? {
				success: true,
				value: result.data
			} : {
				success: false,
				error: result.error
			};
		} });
	}
	processToCompatSchema(schema) {
		const originalStandardSchema = toStandardSchema(schema);
		return { "~standard": {
			version: 1,
			vendor: "mastra",
			validate: (value) => {
				const transformedJsonSchema = this.processToJSONSchema(schema, "input");
				const transformed = this.#traverse(value, transformedJsonSchema);
				return originalStandardSchema["~standard"].validate(transformed);
			},
			jsonSchema: {
				input: () => {
					return this.processToJSONSchema(schema, "input");
				},
				output: () => {
					return this.processToJSONSchema(schema, "output");
				}
			}
		} };
	}
	preProcessJSONNode(schema) {
		if (isAllOfSchema(schema)) this.defaultAllOfHandler(schema);
		if (isObjectSchema(schema)) this.defaultObjectHandler(schema);
		else if (isArraySchema(schema)) this.defaultArrayHandler(schema);
		else if (isNumberSchema(schema)) this.defaultNumberHandler(schema);
		else if (isStringSchema(schema)) this.defaultStringHandler(schema);
	}
	postProcessJSONNode(schema) {
		if (isUnionSchema(schema)) this.defaultUnionHandler(schema);
	}
	#traverse(value, schema) {
		const resolved = this.#resolveAnyOf(schema);
		if (resolved["x-date"] === true && typeof value === "string") return new Date(value);
		if (resolved.type === "array" || Array.isArray(resolved.type) && resolved.type.includes("array")) {
			if (!Array.isArray(value)) return value;
			return value.map((item) => this.#traverse(item, resolved.items));
		}
		if (!(resolved.type === "object" || Array.isArray(resolved.type) && resolved.type.includes("object"))) return value;
		const properties = resolved.properties;
		if (!properties || !value) return value;
		const obj = value;
		for (const key in obj) if (properties[key]) obj[key] = this.#traverse(obj[key], properties[key]);
		return obj;
	}
	#resolveAnyOf(schema) {
		if (Array.isArray(schema.anyOf)) {
			const nonNull = schema.anyOf.find((s) => s.type !== "null");
			if (nonNull) return nonNull;
		}
		return schema;
	}
};
//#endregion
export { ALL_ARRAY_CHECKS, ALL_NUMBER_CHECKS, ALL_STRING_CHECKS, ALL_ZOD_TYPES, AnthropicSchemaCompatLayer, DeepSeekSchemaCompatLayer, GoogleSchemaCompatLayer, JSON_SCHEMA_LIBRARY_OPTIONS, MetaSchemaCompatLayer, OpenAIReasoningSchemaCompatLayer, OpenAISchemaCompatLayer, SUPPORTED_ZOD_TYPES, SchemaCompatLayer, SchemaCompatLayer$1 as SchemaCompatLayerV3, SchemaCompatLayer$2 as SchemaCompatLayerV4, UNSUPPORTED_ZOD_TYPES, applyCompatLayer, applyOpenAICompatToTools, applyOpenAICompatTransforms, convertSchemaToZod, convertZodSchemaToAISDKSchema, ensureAllPropertiesRequired, extractZodSchema, isArr, isNumber, isObj, isOptional, isStandardJSONSchema, isStandardSchema, isStandardSchemaWithJSON, isString, isUnion, isZodType, jsonSchema, prepareJsonSchemaForOpenAIStrictMode, standardSchemaToJSONSchema, toStandardSchema, wrapSchemaWithNullTransform };

//# sourceMappingURL=index.js.map